/**
 * Per-building seed data — GENERATED from crm-inputs/*.xlsx by
 * scripts (see commit). Frontend-first mock; swap for real API per building.
 */

// FALLBACK ONLY. The selector loads the real list from `/complexes/` on mount
// (see apartmentStore.loadApartments). This array is what a user sees when that
// call FAILS — so it must stay in step with the buildings that actually exist,
// or a failed fetch silently shows a plausible but wrong list. It was four
// buildings while nine were live, which is exactly how three buildings went
// missing from the selector without any visible error.
export const APARTMENTS = [
  {
    "id": "brigade-7",
    "name": "Brigade 7 Garden"
  },
  {
    "id": "kumar-princetown",
    "name": "Kumar Princetown"
  },
  {
    "id": "prestige-elysian",
    "name": "Prestige Elysian"
  },
  {
    "id": "prestige-kews",
    "name": "Prestige Kews"
  },
  {
    "id": "prestige-lake-ridge",
    "name": "Prestige Lake Ridge"
  },
  {
    "id": "prestige-waterford",
    "name": "Prestige Waterford"
  },
  {
    "id": "purva-venezia",
    "name": "Purva Venezia"
  },
  {
    "id": "sobha-forest-view",
    "name": "Sobha Forest View"
  },
  {
    "id": "sobha-hillview",
    "name": "Sobha Hillview"
  }
]

export const APARTMENT_DATA = {
  "brigade-7": {
    "enrolments": [
      {
        "parentName": "Vani",
        "childName": "Vismaya",
        "phone": "8867450383",
        "age": 8,
        "program": "Robotics",
        "batch": "Robo 1",
        "days": "Wed, Fri",
        "time": "4:30-6",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Vani",
        "childName": "Vismaya",
        "phone": "8867450383",
        "age": 8,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Tues, Thurs",
        "time": "4:30-6",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Vani",
        "childName": "Vismaya",
        "phone": "8867450383",
        "age": 8,
        "program": "Art",
        "batch": "Art 1",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Sweta Pachlangiya",
        "childName": "Myra Gupta",
        "phone": "9686509372",
        "age": 9,
        "program": "Robotics",
        "batch": "Robo 2",
        "days": "Wed, Fri",
        "time": "6-7:30",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Sweta Pachlangiya",
        "childName": "Myra Gupta",
        "phone": "9686509372",
        "age": 9,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Tues, Thurs",
        "time": "6-7:30",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Sweta Pachlangiya",
        "childName": "Myra Gupta",
        "phone": "9686509372",
        "age": 9,
        "program": "Art",
        "batch": "Art 2",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Nitesh Shetty",
        "childName": "Manasvi Shetty",
        "phone": "9480707908",
        "age": 11,
        "program": "Robotics",
        "batch": "Robo 2",
        "days": "Wed, Fri",
        "time": "6-7:30",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Nitesh Shetty",
        "childName": "Manasvi Shetty",
        "phone": "9480707908",
        "age": 11,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Tues, Thurs",
        "time": "6-7:30",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Nitesh Shetty",
        "childName": "Nakul Shetty",
        "phone": "9480707908",
        "age": 5,
        "program": "Robotics",
        "batch": "Robo 1",
        "days": "Wed, Fri",
        "time": "4:30-6",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Nitesh Shetty",
        "childName": "Nakul Shetty",
        "phone": "9480707908",
        "age": 5,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Tues, Thurs",
        "time": "4:30-6",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Nitesh Shetty",
        "childName": "Nakul Shetty",
        "phone": "9480707908",
        "age": 5,
        "program": "Art",
        "batch": "Art 1",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Archana Sinha",
        "childName": "Vedanshi Kant",
        "phone": "8197103614",
        "age": 9,
        "program": "Robotics",
        "batch": "Robo 2",
        "days": "Wed, Fri",
        "time": "6-7:30",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Archana Sinha",
        "childName": "Vedanshi Kant",
        "phone": "8197103614",
        "age": 9,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Tues, Thurs",
        "time": "6-7:30",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Archana Sinha",
        "childName": "Vedanshi Kant",
        "phone": "8197103614",
        "age": 9,
        "program": "Art",
        "batch": "Art 2",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Archana Sinha",
        "childName": "Tanush Kant",
        "phone": "8197103614",
        "age": 6,
        "program": "Robotics",
        "batch": "Robo 1",
        "days": "Wed, Fri",
        "time": "4:30-6",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Archana Sinha",
        "childName": "Tanush Kant",
        "phone": "8197103614",
        "age": 6,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Tues, Thurs",
        "time": "4:30-6",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Sneha",
        "childName": "Snigdha Athreya",
        "phone": "9845825988",
        "age": 11,
        "program": "Robotics",
        "batch": "Robo 2",
        "days": "Wed, Fri",
        "time": "6-7:30",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Sneha",
        "childName": "Snigdha Athreya",
        "phone": "9845825988",
        "age": 11,
        "program": "Art",
        "batch": "Art 2",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Shruthi M Kashyap",
        "childName": "Siddhan Srivathsa",
        "phone": "9620458858",
        "age": 5,
        "program": "Robotics",
        "batch": "Robo 1",
        "days": "Wed, Fri",
        "time": "4:30-6",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Shruthi M Kashyap",
        "childName": "Siddhan Srivathsa",
        "phone": "9620458858",
        "age": 5,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Tues, Thurs",
        "time": "4:30-6",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Shruthi M Kashyap",
        "childName": "Siddhan Srivathsa",
        "phone": "9620458858",
        "age": 5,
        "program": "Art",
        "batch": "Art 1",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Charu",
        "childName": "Avyaan Bhardwaj",
        "phone": "9591178361",
        "age": 5,
        "program": "Robotics",
        "batch": "Robo 1",
        "days": "Wed, Fri",
        "time": "4:30-6",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Charu",
        "childName": "Avyaan Bhardwaj",
        "phone": "9591178361",
        "age": 5,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Tues, Thurs",
        "time": "4:30-6",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Charu",
        "childName": "Avyaan Bhardwaj",
        "phone": "9591178361",
        "age": 5,
        "program": "Art",
        "batch": "Art 1",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Divya",
        "childName": "Disha",
        "phone": "8123058123",
        "age": 7,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Tues, Thurs",
        "time": "4:30-6",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Divya",
        "childName": "Disha",
        "phone": "8123058123",
        "age": 7,
        "program": "Art",
        "batch": "Art 1",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Trupthi TNS",
        "childName": "Dhriti Holla",
        "phone": "7259844288",
        "age": 9,
        "program": "Robotics",
        "batch": "Robo 2",
        "days": "Wed, Fri",
        "time": "6-7:30",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Trupthi TNS",
        "childName": "Dhriti Holla",
        "phone": "7259844288",
        "age": 9,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Tues, Thurs",
        "time": "6-7:30",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Trupthi TNS",
        "childName": "Dhriti Holla",
        "phone": "7259844288",
        "age": 9,
        "program": "Art",
        "batch": "Art 2",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Tejaswini",
        "childName": "Laksh D K",
        "phone": "7259519090",
        "age": 5,
        "program": "Robotics",
        "batch": "Robo 1",
        "days": "Wed, Fri",
        "time": "4:30-6",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Tejaswini",
        "childName": "Laksh D K",
        "phone": "7259519090",
        "age": 5,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Tues, Thurs",
        "time": "4:30-6",
        "frequency": "2x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Tejaswini",
        "childName": "Laksh D K",
        "phone": "7259519090",
        "age": 5,
        "program": "Art",
        "batch": "Art 1",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Kangan Trivedi",
        "childName": "Raajvi",
        "phone": "9998692665",
        "age": 9,
        "program": "Robotics",
        "batch": "Robo 2",
        "days": "Wed",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Kangan Trivedi",
        "childName": "Raajvi",
        "phone": "9998692665",
        "age": 9,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Ajir Shujahi",
        "childName": "Eva Ajir",
        "phone": "8606742862",
        "age": 10,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Tues",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Ajir Shujahi",
        "childName": "Eva Ajir",
        "phone": "8606742862",
        "age": 10,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Ajir Shujahi",
        "childName": "Eva Ajir",
        "phone": "8606742862",
        "age": 10,
        "program": "Art",
        "batch": "Art 2",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Thejashwini M",
        "childName": "Naksha",
        "phone": "7259647857",
        "age": 7,
        "program": "Robotics",
        "batch": "Robo 1",
        "days": "Wed",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Thejashwini M",
        "childName": "Naksha",
        "phone": "7259647857",
        "age": 7,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Tues",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Thejashwini M",
        "childName": "Naksha",
        "phone": "7259647857",
        "age": 7,
        "program": "Art",
        "batch": "Art 1",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Veda Anurag",
        "childName": "Aarya Anurag Minna",
        "phone": "‪8310149226‬",
        "age": 7,
        "program": "Robotics",
        "batch": "Robo 1",
        "days": "Wed",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Veda Anurag",
        "childName": "Aarya Anurag Minna",
        "phone": "‪8310149226‬",
        "age": 7,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Tues",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Veda Anurag",
        "childName": "Aarya Anurag Minna",
        "phone": "‪8310149226‬",
        "age": 7,
        "program": "Art",
        "batch": "Art 1",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Shruthi KR",
        "childName": "Pradyumna Kashyap",
        "phone": "9743165654",
        "age": 6,
        "program": "Art",
        "batch": "Art 1",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Shruthi KR",
        "childName": "Pradyumna Kashyap",
        "phone": "9743165654",
        "age": 6,
        "program": "Robotics",
        "batch": "Robo 1",
        "days": "Wed",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Shruthi KR",
        "childName": "Pradyumna Kashyap",
        "phone": "9743165654",
        "age": 6,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Tues",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Shruti Bagodi",
        "childName": "Harsha Bagodi",
        "phone": "7338063613",
        "age": 9,
        "program": "Robotics",
        "batch": "Robo 2",
        "days": "Wed",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Shruti Bagodi",
        "childName": "Harsha Bagodi",
        "phone": "7338063613",
        "age": 9,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Tues",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Shruti Bagodi",
        "childName": "Harsha Bagodi",
        "phone": "7338063613",
        "age": 9,
        "program": "Art",
        "batch": "Art 2",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Divya R / Sridhar",
        "childName": "Aaradhyah S",
        "phone": "9789471299",
        "age": 9,
        "program": "Art",
        "batch": "Art 2",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Divya R / Sridhar",
        "childName": "Aaradhyah S",
        "phone": "9789471299",
        "age": 9,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Tues",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-05-04",
        "status": "Active"
      },
      {
        "parentName": "Archana Sinha",
        "childName": "Divyanshi Kant",
        "phone": "8197103614",
        "age": 5,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Thurs",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-05-07",
        "status": "Active"
      },
      {
        "parentName": "Archana Sinha",
        "childName": "Divyanshi Kant",
        "phone": "8197103614",
        "age": 5,
        "program": "Robotics",
        "batch": "Robo 1",
        "days": "Fri",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-05-07",
        "status": "Active"
      },
      {
        "parentName": "Jitendra Kumar",
        "childName": "Tanya j",
        "phone": "9886706880",
        "age": 10,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Tues",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Jitendra Kumar",
        "childName": "Tanya j",
        "phone": "9886706880",
        "age": 10,
        "program": "Art",
        "batch": "Art 2",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Swarnalatha",
        "childName": "Aadarsh Rao",
        "phone": "9500522640",
        "age": 10,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Tues",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Swarnalatha",
        "childName": "Aadarsh Rao",
        "phone": "9500522640",
        "age": 10,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Deviyani Sunkara",
        "childName": "Agastya Manjunath",
        "phone": "7338667733",
        "age": 8,
        "program": "Robotics",
        "batch": "Robo 1",
        "days": "Wed",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Deviyani Sunkara",
        "childName": "Agastya Manjunath",
        "phone": "7338667733",
        "age": 8,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Thurs",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Sneha",
        "childName": "Snigdha Athreya",
        "phone": "9845825988",
        "age": 11,
        "program": "Art",
        "batch": "Art 2",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Trupthi TNS",
        "childName": "Dhriti Holla",
        "phone": "7259844288",
        "age": 9,
        "program": "Art",
        "batch": "Art 2",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Nitesh Shetty",
        "childName": "Manasvi Shetty",
        "phone": "9480707908",
        "age": 11,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Tues",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Nitesh Shetty",
        "childName": "Manasvi Shetty",
        "phone": "9480707908",
        "age": 11,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Nitesh Shetty",
        "childName": "Nakul Shetty",
        "phone": "9480707908",
        "age": 5,
        "program": "Robotics",
        "batch": "Robo 1",
        "days": "Wed",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Nitesh Shetty",
        "childName": "Nakul Shetty",
        "phone": "9480707908",
        "age": 5,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Thurs",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Deepali Mokashi",
        "childName": "Saesha Joshi",
        "phone": "6366708817",
        "age": 11,
        "program": "Art",
        "batch": "Art 2",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Shruthi M Kashyap",
        "childName": "Siddhan Srivathsa",
        "phone": "9620458858",
        "age": 5,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Thurs",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Lohith",
        "childName": "Utsavi",
        "phone": "9620647444",
        "age": 10,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Preeti",
        "childName": "Arvi",
        "phone": "9945318912",
        "age": 10,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Vani",
        "childName": "Vismaya",
        "phone": "8867450383",
        "age": 9,
        "program": "Robotics",
        "batch": "Robo 2",
        "days": "Wed",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Vani",
        "childName": "Vismaya",
        "phone": "8867450383",
        "age": 9,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Tues",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Vani",
        "childName": "Vismaya",
        "phone": "8867450383",
        "age": 9,
        "program": "Art",
        "batch": "Art 2",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Sweta Pachlangiya",
        "childName": "Myra Gupta",
        "phone": "9686509372",
        "age": 9,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Sunitha Prahalada",
        "childName": "Prahil Prahalada",
        "phone": "6366889299",
        "age": 10,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Sunitha Prahalada",
        "childName": "Prahil Prahalada",
        "phone": "6366889299",
        "age": 10,
        "program": "Robotics",
        "batch": "Robo 2",
        "days": "Wed",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      }
    ],
    "trials": [
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Vinita Shetty",
        "childName": "Advita Mahesh",
        "phone": "6363031919",
        "age": 11,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Vinita Shetty",
        "childName": "Kritaanya Mahesh",
        "phone": "6363031919",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Vinita Shetty",
        "childName": "Kritaanya Mahesh",
        "phone": "6363031919",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Vinita Shetty",
        "childName": "Kriyaansh",
        "phone": "6363031919",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Vinita Shetty",
        "childName": "Kriyaansh",
        "phone": "6363031919",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Sweta Pachlangiya",
        "childName": "Nischay",
        "phone": "9686509372",
        "age": 9,
        "program": "",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "No",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Vani",
        "childName": "Vismaya",
        "phone": "8867450383",
        "age": 8,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Vani",
        "childName": "Vismaya",
        "phone": "8867450383",
        "age": 8,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Vani",
        "childName": "Vismaya",
        "phone": "8867450383",
        "age": 8,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Sweta Pachlangiya",
        "childName": "Myra Gupta",
        "phone": "9686509372",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Sweta Pachlangiya",
        "childName": "Myra Gupta",
        "phone": "9686509372",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Sweta Pachlangiya",
        "childName": "Myra Gupta",
        "phone": "9686509372",
        "age": 9,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Nitesh Shetty",
        "childName": "Manasvi Shetty",
        "phone": "9480707908",
        "age": 11,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Nitesh Shetty",
        "childName": "Manasvi Shetty",
        "phone": "9480707908",
        "age": 11,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Nitesh Shetty",
        "childName": "Nakul Shetty",
        "phone": "9480707908",
        "age": 5,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Nitesh Shetty",
        "childName": "Nakul Shetty",
        "phone": "9480707908",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Nitesh Shetty",
        "childName": "Nakul Shetty",
        "phone": "9480707908",
        "age": 5,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Swarnalatha",
        "childName": "Aaddarsh Rao",
        "phone": "9500522640",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Call Back"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Swarnalatha",
        "childName": "Aaddarsh Rao",
        "phone": "9500522640",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Call Back"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Jitendra Kumar",
        "childName": "Reyaansh kumar",
        "phone": "9611222470",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Jitendra Kumar",
        "childName": "Reyaansh kumar",
        "phone": "9611222470",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Jitendra Kumar",
        "childName": "Reyaansh kumar",
        "phone": "9611222470",
        "age": 9,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Archana Sinha",
        "childName": "Vedanshi Kant",
        "phone": "8197103614",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Archana Sinha",
        "childName": "Tanush kant",
        "phone": "8197103614",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Vani",
        "childName": "Vismaya",
        "phone": "8867450383",
        "age": 9,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Smita",
        "childName": "Shreyanshi Sarkar",
        "phone": "9886687910/\n9127067610",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-04-28",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Call Back"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Smita",
        "childName": "Shreyanshi Sarkar",
        "phone": "9886687910/\n9127067610",
        "age": 9,
        "program": "Art",
        "trialDate": "2026-04-28",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Call Back"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Divya R / Sridhar",
        "childName": "Aaradhyah S",
        "phone": "9789471299",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "2026-04-27",
        "converted": "Yes",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Divya R / Sridhar",
        "childName": "Aaradhyah S",
        "phone": "9789471299",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "2026-04-27",
        "converted": "Yes",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Divya R / Sridhar",
        "childName": "Aaradhyah S",
        "phone": "9789471299",
        "age": 9,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "2026-04-27",
        "converted": "Yes",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Sneha",
        "childName": "Snigdha Athreya",
        "phone": "9845825988",
        "age": 11,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": "Call Back"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Sneha",
        "childName": "Snigdha Athreya",
        "phone": "9845825988",
        "age": 11,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": "Call Back"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Ashutosh Pradhan",
        "childName": "Reyansh Pradhan",
        "phone": "8373906024",
        "age": 8,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Ranjini Shivanna",
        "childName": "Manvi Gokul",
        "phone": "9739773665",
        "age": 8,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Call Back"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Ranjini Shivanna",
        "childName": "Manvi Gokul",
        "phone": "9739773665",
        "age": 8,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Call Back"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Tejaswini",
        "childName": "Laksh D K",
        "phone": "7259519090",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "2026-04-27",
        "converted": "Yes",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Tejaswini",
        "childName": "Laksh D K",
        "phone": "7259519090",
        "age": 5,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Shruthi M Kashyap",
        "childName": "Siddhan Srivathsa",
        "phone": "9620458858",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Shruthi M Kashyap",
        "childName": "Siddhan Srivathsa",
        "phone": "9620458858",
        "age": 5,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Avyaan Bhardwaj",
        "childName": "No",
        "phone": "9591178361",
        "age": 5,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": "Call Back"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Avyaan Bhardwaj",
        "childName": "No",
        "phone": "9591178361",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": "Call Back"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Bharath Dev",
        "childName": "Dhrithi Bharath",
        "phone": "9972596069",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "2026-04-28",
        "converted": "Follow-up Pending",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Deviyani Sunkara",
        "childName": "Agastya Manjunath",
        "phone": "7338667733",
        "age": 8,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "2026-04-29",
        "converted": "Yes",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Divya",
        "childName": "Disha",
        "phone": "8123058123",
        "age": 7,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "2026-04-28",
        "converted": "Yes",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Smita",
        "childName": "Shreyanshi Sarkar",
        "phone": "9127067610/\n9127067610",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Call Back"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Gurucharan",
        "childName": "Koushik G Bharadwaj",
        "phone": "9880292864/\n9036296844",
        "age": 10,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Call Back"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Gurucharan",
        "childName": "Khushi G Bharadwaj",
        "phone": "9880292864/\n9036296844",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Call Back"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Ajir Shujahi",
        "childName": "Eva Ajir",
        "phone": "8606742862",
        "age": 10,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "2026-04-27",
        "converted": "Yes",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Ajir Shujahi",
        "childName": "Eva Ajir",
        "phone": "8606742862",
        "age": 10,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "2026-04-27",
        "converted": "Yes",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Nagaraj",
        "childName": "Advika N H",
        "phone": "9844758776",
        "age": 8,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Nagaraj",
        "childName": "Advika N H",
        "phone": "9844758776",
        "age": 8,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-25",
        "parentName": "Nagaraj",
        "childName": "Advika N H",
        "phone": "9844758776",
        "age": 8,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-25",
        "parentName": "Murali",
        "childName": "Samvitha",
        "phone": "9986387815",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Not Interested"
      },
      {
        "enquiryDate": "2026-04-25",
        "parentName": "Murali",
        "childName": "Samvitha",
        "phone": "9986387815",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-25",
        "parentName": "Murali",
        "childName": "Samvitha",
        "phone": "9986387815",
        "age": 9,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Preeti Babladi",
        "childName": "Aaradhya Babladi",
        "phone": "8867642499",
        "age": 10,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "2026-05-02",
        "converted": "Follow-up Pending",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Preeti Babladi",
        "childName": "Aaradhya Babladi",
        "phone": "8867642499",
        "age": 10,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "2026-05-02",
        "converted": "Follow-up Pending",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-25",
        "parentName": "Preeti Babladi",
        "childName": "Aaradhya Babladi",
        "phone": "8867642499",
        "age": 10,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "2026-05-02",
        "converted": "Follow-up Pending",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Kangan Trivedi",
        "childName": "Raajvi",
        "phone": "9998692665",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "2026-04-27",
        "converted": "Yes",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Kangan Trivedi",
        "childName": "Raajvi",
        "phone": "9998692665",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "2026-04-27",
        "converted": "Yes",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-25",
        "parentName": "Kangan Trivedi",
        "childName": "Raajvi",
        "phone": "9998692665",
        "age": 9,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "2026-04-27",
        "converted": "Yes",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Kangan Trivedi",
        "childName": "Nirvi",
        "phone": "9998692665",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "2026-04-27",
        "converted": "Yes",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Kangan Trivedi",
        "childName": "Nirvi",
        "phone": "9998692665",
        "age": 5,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "2026-04-27",
        "converted": "Yes",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Glitty Jacob",
        "childName": "Eva Ann Jiju",
        "phone": "9902532594",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "2026-04-27",
        "converted": "Follow-up Pending",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-25",
        "parentName": "Glitty Jacob",
        "childName": "Eva Ann Jiju",
        "phone": "9902532594",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "2026-04-27",
        "converted": "Follow-up Pending",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-25",
        "parentName": "Thejashwini M",
        "childName": "Naksha",
        "phone": "7259647857",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "2026-04-25",
        "parentName": "Thejashwini M",
        "childName": "Naksha",
        "phone": "7259647857",
        "age": 7,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "2026-04-25",
        "parentName": "Trupthi TNS",
        "childName": "Dhriti Holla",
        "phone": "7259844288",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-25",
        "parentName": "Trupthi TNS",
        "childName": "Dhriti Holla",
        "phone": "7259844288",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-25",
        "parentName": "Trupthi TNS",
        "childName": "Dhriti Holla",
        "phone": "7259844288",
        "age": 9,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Archana Sinha",
        "childName": "Tanush kant",
        "phone": "8197103614",
        "age": 6,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Archana Sinha",
        "childName": "Vedanshi Kant",
        "phone": "8197103614",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Archana Sinha",
        "childName": "Divyanshi Kant",
        "phone": "8197103614",
        "age": 5,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "No",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Archana Sinha",
        "childName": "Vedanshi Kant",
        "phone": "8197103614",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Archana Sinha",
        "childName": "Vedanshi Kant",
        "phone": "8197103614",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "No",
        "callStatus": ""
      },
      {
        "enquiryDate": "2026-04-25",
        "parentName": "Sindhu NV/Panendra",
        "childName": "Riyansh M",
        "phone": "8951815114",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "2026-04-29",
        "converted": "Follow-up Pending",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "2026-04-25",
        "parentName": "Jitendra Kumar",
        "childName": "neyashree",
        "phone": "9611222470",
        "age": "",
        "program": "Public Speaking",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "2026-04-24",
        "parentName": "Nitesh Shetty",
        "childName": "Manasvi Shetty",
        "phone": "9480707908",
        "age": 11,
        "program": "Art",
        "trialDate": "2026-04-25",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "",
        "childName": "Tanya",
        "phone": "",
        "age": "",
        "program": "Art",
        "trialDate": "2026-05-04",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      }
    ],
    "inventory": [
      {
        "item": "Lanyards",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 23,
        "received": 15,
        "balance": 8,
        "notes": ""
      },
      {
        "item": "Guess me",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": "No cards have come"
      },
      {
        "item": "Watch your step",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 2,
        "received": 2,
        "balance": "",
        "notes": "2 Mats, 1 set of cards, 2 Mini mats"
      },
      {
        "item": "Debate duel",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": "no level 3 cards"
      },
      {
        "item": "Tale trail",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": 2,
        "received": "",
        "balance": "",
        "notes": "2 Mats, 1 Set Cards, need one more cards"
      },
      {
        "item": "speech a palooza (WF)",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": "no cards - rest is there"
      },
      {
        "item": "Art Venture, Level 2",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Colour Flip",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Shape Fusion",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": 3,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art Gym, level 4",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": 4,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art Gym, level 5",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": 4,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art Gym, Level 6",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": 3,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art queue cards, Animals (B1)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": 3,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art queue cards, Backgrounds",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": 4,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art queue cards, Food",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art Gym, level 3",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": 5,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Aprons",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 24,
        "received": 24,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Magnet Tiles",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Water colour sheets (A5)",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Paper plates",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 3,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Water colour palatte",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": 10,
        "received": 10,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Paint bottles",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 7,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Glue",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 3,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Tissues",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 2,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "eraser",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Sharpner",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Gum Tapes",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 4,
        "received": 4,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Colour Pencils",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 5,
        "received": 5,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Drawing Pencils",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 2,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Wax Crayons",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 3,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Brushes",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 2,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Water colour Tubes",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Mixing plates and bowls",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": "",
        "received": 12,
        "balance": "",
        "notes": ""
      },
      {
        "item": "A3 Papers (130 gsm) 1 set",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Robotics manual",
        "category": "Robotics",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": "",
        "received": 5,
        "balance": "",
        "notes": ""
      },
      {
        "item": "music books level 1",
        "category": "Music",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": "",
        "received": 2,
        "balance": "",
        "notes": ""
      },
      {
        "item": "music books level 2",
        "category": "Music",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": "",
        "received": 2,
        "balance": "",
        "notes": ""
      },
      {
        "item": "music books level 3",
        "category": "Music",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": "",
        "received": 2,
        "balance": "",
        "notes": ""
      },
      {
        "item": "At home brochures",
        "category": "Marketing",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 28,
        "received": 28,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Robotics KIT (WF)",
        "category": "Robotics",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": 12,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Sanitizer",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 2,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Masking tape",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 2,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Cellotape",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Disposable plates",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "faber castle colours bottle",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Only for Trials",
        "dispatched": 7,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Fevicol",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Water cups",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Plastic mat",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Screw driver (wf)",
        "category": "Robotics",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": 7,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art Gym",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Regular",
        "dispatched": "",
        "received": 16,
        "balance": "",
        "notes": "Level 3 - 5\nLevel 4 - 4\nLevel 5 - 4\nLevel 6 - 3"
      },
      {
        "item": "A3 Papers - Black",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Regular",
        "dispatched": "",
        "received": 8,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Pipe Cleaners",
        "category": "Robotics",
        "capexOpex": "Capex",
        "purpose": "Regular",
        "dispatched": "",
        "received": 150,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Improv Survival",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "Mat Pending"
      },
      {
        "item": "A3 Cartridge",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": "1 set we already had"
      },
      {
        "item": "Train of thought",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Spaggle",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "Yet to receive/unclear"
      },
      {
        "item": "Timer(watch your step)",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Erasable markers",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 10,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Tokens (1 Pack - Around !00 Pcs)",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "A4 sheets",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": "1 additional set we have"
      },
      {
        "item": "Soft ball",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Speaker",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Dice (4)",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 4,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Meeples (12)",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "What is this Shantanu Sharma ?"
      },
      {
        "item": "Clay",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "A4 catridge (100)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Colour papers (100)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Glue stick (10)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 12,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Erasers (20)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 20,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Sharpeners (20)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 20,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Aprons (12)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 12,
        "balance": "",
        "notes": "we have 36 Aprons - 3 sets"
      },
      {
        "item": "Masking tape (2)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 4,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Water Jars (6)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 3,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Mystery Box narrative + Match me",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Scissors (Set of 3)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 3,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Child Safe Scirssors",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 5,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Rulers (30 Cms)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 10,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Yarn",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 11,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Sequins",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 7,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Plastic Jars",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 5,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Plastic Sheet (For Mess Avoidance)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": "we have one more - will need a bigger one too"
      },
      {
        "item": "Tempera paint bottle set",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 13,
        "balance": "",
        "notes": "we have 7 additional"
      },
      {
        "item": "Fevicryl Acrylic Cobalt blue -500 ml bottle / cerilian blue",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Pencils  - Faber castle Shading pencils",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 12,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Pencils  - Faber castle colour pencils - 24 shades",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 24,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Pastels - Oil pastels- 50 shades",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Pastels - Dry soft pastels",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Crayons  - Domes plastic crayons 28 shades",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 2,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Sketchpens - Domes Brush pens",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 2,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Sketchpens - Luxor black signpens",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Paint Brushes",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 10,
        "balance": "",
        "notes": "We have 14 additional brushes"
      },
      {
        "item": "Mixing Palettes",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 10,
        "balance": "",
        "notes": "we have additional 10"
      },
      {
        "item": "Single hole Punching machine",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "White Pencil",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 2,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Debate Duel",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "we have not received"
      },
      {
        "item": "Watch Your Step",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": "2 Mats, 1 set of cards, 2 Mini mats"
      },
      {
        "item": "Water Paint (Set of 12)",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Large Palette",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Round Brush Set",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Aprons",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 12,
        "balance": "",
        "notes": "we have additional 2 sets as well"
      },
      {
        "item": "Art Book",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 30,
        "balance": "",
        "notes": ""
      },
      {
        "item": "art club worksheets",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Logo front sheet",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Play-Dough",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Fevicol",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Battery Fairy  Light (4 pcs)",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Texture sheets",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Pipe cleaners (100 Pcs)",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 156,
        "balance": "",
        "notes": ""
      },
      {
        "item": "A4 Sheets (Set of 100 ) - Catridge",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "A3 Sheets",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Neon Paint (4 Shades) - 15 ml",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "White Clay (Air-Drying)",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Sea-Shells (Mixed)",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Roving wool (Pink, blue, green)",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Bubble Sheet (1 Roll)",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Small Beads",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Rhinestones",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Sand",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Colourful Craft Paper (Thick)",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Ribbons (Chiffon)",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Wooden Stick",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "why do I need this Shantanu Sharma ?"
      },
      {
        "item": "Refined Flour",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "why do I need this Shantanu Sharma ?"
      },
      {
        "item": "Coconut Oil",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "why do I need this Shantanu Sharma ?"
      },
      {
        "item": "Cream of Tartar",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "why do I need this Shantanu Sharma ?"
      },
      {
        "item": "Salt",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "why do I need this Shantanu Sharma ?"
      },
      {
        "item": "Q-tips",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Fabric Glue",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Googly Eyes",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Acrylic Paint",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Paper cups",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Paper plates",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received\nhowever, we already had the set"
      },
      {
        "item": "Kite paper",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "why do I need this Shantanu Sharma ?"
      },
      {
        "item": "Balloons",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "why do I need this Shantanu Sharma ?"
      },
      {
        "item": "Plastic cup lids",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "why do I need this Shantanu Sharma ?"
      },
      {
        "item": "MDF round board",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "why do I need this Shantanu Sharma ?"
      },
      {
        "item": "White socks",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "why do I need this Shantanu Sharma ?"
      },
      {
        "item": "Cotton",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Round Colour stickers",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Paper bag / Large envelopes",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Pom poms",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Rubber bands",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      },
      {
        "item": "Parchment / wax paper",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": "have not received"
      }
    ],
    "issues": [],
    "payout": {
      "sharePercent": 15,
      "accountDetails": "BRIGADE SEVEN GARDENS APARTMENT\nOWNERS ASSOCIATION - EVENTS\nA/c No – 6149716284\nIFSC Code KKBK0008122\nKotak Mahindra Bank, Bellandur",
      "rows": [
        {
          "month": "May '26",
          "totalRev": 48484,
          "apartmentShare": 7272.6,
          "paid": false,
          "netTotal": 41088.14,
          "netApartment": 6163.22,
          "notes": ""
        },
        {
          "month": "June '26",
          "totalRev": 57250,
          "apartmentShare": 8587.5,
          "paid": false,
          "netTotal": 48516.95,
          "netApartment": 7277.54,
          "notes": "June will not be paid right now"
        }
      ]
    },
    "payments": [
      {
        "parentName": "Archana Sinha",
        "children": "Vedanshi Kant, Tanush Kant",
        "categories": "All Three, Two Categories",
        "month": "",
        "amount": 4498,
        "status": "Paid",
        "paymentId": "pay_Si2GNiI2RqaFlY, pay_Si2LC2EIGNePIO",
        "date": "2026-04-26",
        "phone": "918197103614"
      },
      {
        "parentName": "Ajir shujahi",
        "children": "Eva Ajir",
        "categories": "All Three",
        "month": "",
        "amount": 2500,
        "status": "Paid",
        "paymentId": "pay_Skuq3yXeBI8bpk",
        "date": "2026-05-03",
        "phone": "918606742862"
      },
      {
        "parentName": "Vani kantli",
        "children": "Vismaya chaitanya",
        "categories": "All Three",
        "month": "",
        "amount": 2500,
        "status": "Paid",
        "paymentId": "pay_SheEaulnjGeWvf",
        "date": "2026-04-25",
        "phone": "918867450383"
      },
      {
        "parentName": "Trupthi TS",
        "children": "Dhruti Holla",
        "categories": "All Three",
        "month": "",
        "amount": 2500,
        "status": "Paid",
        "paymentId": "pay_Si0SwXN6kbbiBy",
        "date": "2026-04-26",
        "phone": "917259844288"
      },
      {
        "parentName": "Thejashwini M",
        "children": "Naksha B",
        "categories": "All Three",
        "month": "",
        "amount": 2500,
        "status": "Paid",
        "paymentId": "pay_Sk3fi2myuXHVCM",
        "date": "2026-05-01",
        "phone": "917259647857"
      },
      {
        "parentName": "Tejaswini H B",
        "children": "Laksh D K",
        "categories": "All Three",
        "month": "",
        "amount": 2500,
        "status": "Paid",
        "paymentId": "pay_SilYvldjEJd0Xk",
        "date": "2026-04-28",
        "phone": "917259519090"
      },
      {
        "parentName": "Sweta Pachlangiya",
        "children": "Myra Sweta Gupta",
        "categories": "All Three",
        "month": "",
        "amount": 2500,
        "status": "Paid",
        "paymentId": "pay_Shmx0hpUWBJDFD",
        "date": "2026-04-25",
        "phone": "919686509372"
      },
      {
        "parentName": "Shruti bagodi",
        "children": "Harsha",
        "categories": "All Three",
        "month": "",
        "amount": 2500,
        "status": "Paid",
        "paymentId": "pay_SlHDnQcumNrrT7",
        "date": "2026-05-04",
        "phone": "917338063613"
      },
      {
        "parentName": "Shruthi M Kashyap",
        "children": "Siddhan T Srivathsa",
        "categories": "All Three",
        "month": "",
        "amount": 2500,
        "status": "Paid",
        "paymentId": "pay_SiCVrZ5tPpMm4q",
        "date": "2026-04-26",
        "phone": "919620458858"
      },
      {
        "parentName": "Shruthi K R",
        "children": "Pradyumna Kashyap",
        "categories": "All Three",
        "month": "",
        "amount": 2500,
        "status": "Paid",
        "paymentId": "pay_SlH9jxqzO1GvJn",
        "date": "2026-05-04",
        "phone": "919743165654"
      },
      {
        "parentName": "Nitesh Shetty",
        "children": "Nakul N Shetty, Manasvi N Shetty",
        "categories": "All Three, Two Categories, once/week, PS, Twice/week",
        "month": "",
        "amount": 2500,
        "status": "Paid",
        "paymentId": "pay_Si1LidQ5HqdKkc",
        "date": "2026-04-26",
        "phone": "919480707908"
      },
      {
        "parentName": "Charulatha Prabhu",
        "children": "Avyaan Bhardwaj",
        "categories": "All Three",
        "month": "",
        "amount": 2500,
        "status": "Paid",
        "paymentId": "pay_SiCVodwbZ86tcH",
        "date": "2026-04-26",
        "phone": "919591178361"
      },
      {
        "parentName": "Veda Anurag",
        "children": "Aarya Anurag Minna",
        "categories": "All Three",
        "month": "",
        "amount": 2500,
        "status": "Paid",
        "paymentId": "pay_SlBSpyHrQ1bDpX",
        "date": "2026-05-04",
        "phone": "918310149226"
      },
      {
        "parentName": "Shashi Prakash",
        "children": "Divyanshi Kant",
        "categories": "Two Categories",
        "month": "",
        "amount": 1998,
        "status": "Paid",
        "paymentId": "pay_SlgavOi2bc5Xfe",
        "date": "2026-05-05",
        "phone": "917761094637"
      },
      {
        "parentName": "Sneha Chandrasekhar",
        "children": "Snigdha Athreya",
        "categories": "Two Categories",
        "month": "",
        "amount": 1998,
        "status": "Paid",
        "paymentId": "pay_SiABFCZWnTnecE",
        "date": "2026-04-26",
        "phone": "919845825988"
      },
      {
        "parentName": "Kangan Trivedi",
        "children": "Raajvi Trivedi",
        "categories": "Two Categories",
        "month": "",
        "amount": 1998,
        "status": "Paid",
        "paymentId": "pay_SkT1wLPZEY9fwQ",
        "date": "2026-05-02",
        "phone": "919998692665"
      },
      {
        "parentName": "Jitendra Kumar",
        "children": "Tanya j",
        "categories": "Two Categories",
        "month": "",
        "amount": 1998,
        "status": "Paid",
        "paymentId": "pay_So3ZomqiuzPLde",
        "date": "2026-05-11",
        "phone": "919886706880"
      },
      {
        "parentName": "Divyasree M",
        "children": "Disha polisetty",
        "categories": "Two Categories",
        "month": "",
        "amount": 1998,
        "status": "Paid",
        "paymentId": "pay_SiQO36wVfkxFQA",
        "date": "2026-04-27",
        "phone": "918123058123"
      },
      {
        "parentName": "Divya Sridhar",
        "children": "Aaradhyah S",
        "categories": "Two Categories",
        "month": "",
        "amount": 1998,
        "status": "Paid",
        "paymentId": "pay_SlHLpE3AvYumuz",
        "date": "2026-05-04",
        "phone": "919789471299"
      },
      {
        "parentName": "Seema Bhandary",
        "children": "Manasvi N Shetty",
        "categories": "Two Categories",
        "month": "",
        "amount": 1998,
        "status": "Paid",
        "paymentId": "pay_Si1IH0CpaCuLdb",
        "date": "2026-04-26",
        "phone": "919986611848"
      },
      {
        "parentName": "Swarnalatha",
        "children": "Aadarsh Rao",
        "categories": "One Category, Twice/week",
        "month": "",
        "amount": 5400,
        "status": "Paid",
        "paymentId": "pay_Somo6zV3JEQyta",
        "date": "2026-05-13",
        "phone": "919500522640"
      },
      {
        "parentName": "Deviyani Sunkara",
        "children": "Agastya Manjunath",
        "categories": "Two Categories, once/week",
        "month": "",
        "amount": 6300,
        "status": "Paid",
        "paymentId": "pay_Sp9vm9ysKaIORM",
        "date": "2026-05-14",
        "phone": "917338667733"
      },
      {
        "parentName": "Deepali Mokashi",
        "children": "Saesha Joshi",
        "categories": "Art, Once/Week",
        "month": "",
        "amount": 3000,
        "status": "Paid",
        "paymentId": "pay_SuOAAcNnO12upJ",
        "date": "2026-05-27",
        "phone": "6366708817"
      },
      {
        "parentName": "Preeti",
        "children": "Arvi",
        "categories": "PS, Once/Week",
        "month": "",
        "amount": 3000,
        "status": "Paid",
        "paymentId": "pay_SupxTKjIMzU9FH",
        "date": "2026-05-28",
        "phone": "9945318912"
      },
      {
        "parentName": "Lohith MV",
        "children": "Utsavi Gowda",
        "categories": "",
        "month": "",
        "amount": 3000,
        "status": "Paid",
        "paymentId": "pay_SvToBbi2In557i",
        "date": "2026-05-30",
        "phone": "9620647444"
      },
      {
        "parentName": "Sunitha Prahalada",
        "children": "Prahil Prahalada",
        "categories": "6366889299",
        "month": "",
        "amount": 6300,
        "status": "Paid",
        "paymentId": "pay_SwkS7pRSMpgAn3",
        "date": "2026-06-02",
        "phone": "6366889299"
      }
    ],
    "attendance": {
      "week": "Recent sessions",
      "dates": [
        "2026-06-01",
        "2026-06-02",
        "2026-06-03",
        "2026-06-04",
        "2026-06-05"
      ],
      "rows": [
        {
          "childName": "Aadarsh Rao",
          "batch": "PS 2",
          "marks": [
            "",
            "P",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Aadarsh Rao",
          "batch": "PS 2",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Agastya Manjunath",
          "batch": "Robo 1",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Agastya Manjunath",
          "batch": "PS 1",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Snigdha Athreya",
          "batch": "Art 2",
          "marks": [
            "P",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Dhriti Holla",
          "batch": "Art 2",
          "marks": [
            "P",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Manasvi Shetty",
          "batch": "PS 2",
          "marks": [
            "",
            "P",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Manasvi Shetty",
          "batch": "PS 2",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Nakul Shetty",
          "batch": "Robo 1",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Nakul Shetty",
          "batch": "PS 1",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Saesha Joshi",
          "batch": "Art 2",
          "marks": [
            "P",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Siddhan Srivathsa",
          "batch": "PS 1",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Utsavi",
          "batch": "PS 2",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Arvi",
          "batch": "PS 2",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        }
      ]
    },
    "enrolmentOptions": {
      "families": [
        {
          "id": "f1",
          "name": "Vani",
          "children": [
            "Vismaya"
          ]
        },
        {
          "id": "f2",
          "name": "Sweta Pachlangiya",
          "children": [
            "Myra Gupta"
          ]
        },
        {
          "id": "f3",
          "name": "Nitesh Shetty",
          "children": [
            "Manasvi Shetty",
            "Nakul Shetty"
          ]
        },
        {
          "id": "f4",
          "name": "Archana Sinha",
          "children": [
            "Divyanshi Kant",
            "Tanush Kant",
            "Vedanshi Kant"
          ]
        },
        {
          "id": "f5",
          "name": "Sneha",
          "children": [
            "Snigdha Athreya"
          ]
        },
        {
          "id": "f6",
          "name": "Shruthi M Kashyap",
          "children": [
            "Siddhan Srivathsa"
          ]
        },
        {
          "id": "f7",
          "name": "Charu",
          "children": [
            "Avyaan Bhardwaj"
          ]
        },
        {
          "id": "f8",
          "name": "Divya",
          "children": [
            "Disha"
          ]
        },
        {
          "id": "f9",
          "name": "Trupthi TNS",
          "children": [
            "Dhriti Holla"
          ]
        },
        {
          "id": "f10",
          "name": "Tejaswini",
          "children": [
            "Laksh D K"
          ]
        },
        {
          "id": "f11",
          "name": "Kangan Trivedi",
          "children": [
            "Raajvi"
          ]
        },
        {
          "id": "f12",
          "name": "Ajir Shujahi",
          "children": [
            "Eva Ajir"
          ]
        },
        {
          "id": "f13",
          "name": "Thejashwini M",
          "children": [
            "Naksha"
          ]
        },
        {
          "id": "f14",
          "name": "Veda Anurag",
          "children": [
            "Aarya Anurag Minna"
          ]
        },
        {
          "id": "f15",
          "name": "Shruthi KR",
          "children": [
            "Pradyumna Kashyap"
          ]
        },
        {
          "id": "f16",
          "name": "Shruti Bagodi",
          "children": [
            "Harsha Bagodi"
          ]
        },
        {
          "id": "f17",
          "name": "Divya R / Sridhar",
          "children": [
            "Aaradhyah S"
          ]
        },
        {
          "id": "f18",
          "name": "Jitendra Kumar",
          "children": [
            "Tanya j"
          ]
        },
        {
          "id": "f19",
          "name": "Swarnalatha",
          "children": [
            "Aadarsh Rao"
          ]
        },
        {
          "id": "f20",
          "name": "Deviyani Sunkara",
          "children": [
            "Agastya Manjunath"
          ]
        },
        {
          "id": "f21",
          "name": "Deepali Mokashi",
          "children": [
            "Saesha Joshi"
          ]
        },
        {
          "id": "f22",
          "name": "Lohith",
          "children": [
            "Utsavi"
          ]
        },
        {
          "id": "f23",
          "name": "Preeti",
          "children": [
            "Arvi"
          ]
        },
        {
          "id": "f24",
          "name": "Sunitha Prahalada",
          "children": [
            "Prahil Prahalada"
          ]
        }
      ],
      "programs": [
        "Art",
        "Public Speaking",
        "Robotics",
        "Dance"
      ]
    },
    "dashboard": {
      "activeEnrolments": 75,
      "activeFamilies": 24,
      "trialsThisMonth": 79,
      "openIssues": 0,
      "revenueByMonth": [
        {
          "month": "May '26",
          "revenue": 48484,
          "apartmentShare": 7272.6,
          "paid": false
        },
        {
          "month": "June '26",
          "revenue": 57250,
          "apartmentShare": 8587.5,
          "paid": false
        }
      ],
      "revenueByProgram": [
        {
          "program": "Public Speaking",
          "enrolments": 33,
          "revenue": 41800
        },
        {
          "program": "Robotics",
          "enrolments": 21,
          "revenue": 36700
        },
        {
          "program": "Art",
          "enrolments": 21,
          "revenue": 21000
        }
      ],
      "attendance": {
        "present": 5,
        "absent": 0,
        "holiday": 0
      }
    }
  },
  "prestige-kews": {
    "enrolments": [
      {
        "parentName": "Rimisha Raghavan",
        "childName": "Niyara Narayanan",
        "phone": "9986698506",
        "age": 8,
        "program": "Public Speaking",
        "batch": "Thurs",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Anushree Kanodia",
        "childName": "Avikaa luthra",
        "phone": "9818862436",
        "age": 6,
        "program": "Public Speaking",
        "batch": "Thurs",
        "days": "Thurs",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Nithya",
        "childName": "Advait",
        "phone": "8971968686",
        "age": 8,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:00 PM – 1:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Saurabh Pandey",
        "childName": "Saavi Pandey",
        "phone": "9740228554",
        "age": 7,
        "program": "Public Speaking",
        "batch": "Thurs",
        "days": "Thurs",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Shalu Sharma",
        "childName": "Snehanshika Bhusan",
        "phone": "7411592133",
        "age": 7,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "12:00 PM – 1:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Sanmathi Rajesh",
        "childName": "9448462266",
        "phone": "9448162266",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Thurs",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Radhika Tharuvara",
        "childName": "Bhadra R",
        "phone": "9964046790",
        "age": 6,
        "program": "Public Speaking",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:00 PM – 1:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Chhavi",
        "childName": "Saanvi Jaiswal",
        "phone": "9742024234",
        "age": 11,
        "program": "Public Speaking",
        "batch": "Thurs",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Chhavi",
        "childName": "Jaanvi Jaiswal",
        "phone": "9742024234",
        "age": 7,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "12:00 PM – 1:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Meenu",
        "childName": "Maanvik Singh",
        "phone": "8884463337",
        "age": 7,
        "program": "Public Speaking",
        "batch": "Thurs",
        "days": "Thurs",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Neha Kapoor",
        "childName": "Ahaana Gupta",
        "phone": "9901150245",
        "age": 7,
        "program": "Robotics",
        "batch": "Fri",
        "days": "Fri",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Navaneeth Varma",
        "childName": "Kiara Varma",
        "phone": "9902470412",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Thurs",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Rimisha Raghavan",
        "childName": "Niyara Narayanan",
        "phone": "9986698506",
        "age": 8,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:00 PM – 1:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Anushree Kanodia",
        "childName": "Avikaa luthra",
        "phone": "9818862436",
        "age": 6,
        "program": "Robotics",
        "batch": "Fri",
        "days": "Fri",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Shalu Sharma",
        "childName": "Snehanshika Bhusan",
        "phone": "7411592133",
        "age": 7,
        "program": "Dance",
        "batch": "Mon",
        "days": "Mon",
        "time": "5:00 PM – 6:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Keitaki Natu Agarwal",
        "childName": "Yajur Agarwal",
        "phone": "9871719746",
        "age": 5,
        "program": "Robotics",
        "batch": "Fri",
        "days": "Fri",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Afshan Jabeen",
        "childName": "",
        "phone": "8884006661",
        "age": 11,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Ananda",
        "childName": "Adwait Mishra",
        "phone": "95382 00438",
        "age": 9,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Ananda",
        "childName": "Adwait Mishra",
        "phone": "95382 00438",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Thurs",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Ananda Prava Dash",
        "childName": "Adwait Mishra",
        "phone": "9538200438",
        "age": 9,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Ananda Prava Dash",
        "childName": "Adwait Mishra",
        "phone": "9538200438",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Thurs",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Ankita chhabra",
        "childName": "Ruhi bhambri",
        "phone": "9321394607",
        "age": 7,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:00 PM – 1:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Paused"
      },
      {
        "parentName": "Ansul",
        "childName": "araya",
        "phone": "9916388816",
        "age": 7,
        "program": "Robotics",
        "batch": "Fri",
        "days": "Fri",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Ansul",
        "childName": "anisha",
        "phone": "9916388816",
        "age": 7,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "12:00 PM – 1:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Anushree Kanodia",
        "childName": "Avikaa luthra",
        "phone": "9818862436",
        "age": 6,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "12:00 PM – 1:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Asha Sandeep",
        "childName": "Anshika Musti",
        "phone": "9538048189",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Thurs",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Asha Sandeep",
        "childName": "Anshika Musti",
        "phone": "9538048189",
        "age": 9,
        "program": "Robotics",
        "batch": "Fri",
        "days": "Fri",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Ashutosh Singh",
        "childName": "Evanya Singh",
        "phone": "9870600543",
        "age": 5,
        "program": "Public Speaking",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:00 PM – 1:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Esha Gupta",
        "childName": "Aritro",
        "phone": "9731936040",
        "age": 6,
        "program": "Robotics",
        "batch": "Fri",
        "days": "Fri",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Esha Gupta",
        "childName": "Aritro",
        "phone": "9731936040",
        "age": 6,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "12:00 PM – 1:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "hardik",
        "childName": "vatsal",
        "phone": "7259002266",
        "age": 9,
        "program": "Robotics",
        "batch": "Fri",
        "days": "Fri",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "hardik",
        "childName": "vatsal",
        "phone": "9986622260",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Thurs",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "hardik",
        "childName": "vatsal",
        "phone": "9986622260",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Thurs",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Heena",
        "childName": "Kyra Tayal",
        "phone": "9008102202",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Heena",
        "childName": "Kyra Tayal",
        "phone": "9008102202",
        "age": 9,
        "program": "Robotics",
        "batch": "Fri",
        "days": "Fri",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Mayur Vrushabhendra",
        "childName": "Ronith",
        "phone": "9972909192",
        "age": 9,
        "program": "Robotics",
        "batch": "Fri",
        "days": "Fri",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Mayur Vrushabhendra",
        "childName": "Ronith",
        "phone": "9972909192",
        "age": 9,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Navaneeth Varma",
        "childName": "Kiara Varma",
        "phone": "9902470412",
        "age": 9,
        "program": "Robotics",
        "batch": "Fri",
        "days": "Fri",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Neha Goyal",
        "childName": "Advay Agarwal",
        "phone": "9739360160",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Neha Goyal",
        "childName": "Advay Agarwal",
        "phone": "9739360160",
        "age": 9,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:00 PM – 1:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Neha Kapoor",
        "childName": "Ahaana Gupta",
        "phone": "9901150245",
        "age": 7,
        "program": "Robotics",
        "batch": "Fri",
        "days": "Fri",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Neha Kapoor",
        "childName": "Ahaana Gupta",
        "phone": "9901150245",
        "age": 7,
        "program": "Dance",
        "batch": "Mon",
        "days": "Mon",
        "time": "6:15 PM – 7:15",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "NEHA MISRA",
        "childName": "AASHVI MISHRA",
        "phone": "9886484951",
        "age": 10,
        "program": "Robotics",
        "batch": "Fri",
        "days": "Fri",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "pooja",
        "childName": "aadya gupta",
        "phone": "8882698499",
        "age": 10,
        "program": "Robotics",
        "batch": "Fri",
        "days": "Fri",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "pooja",
        "childName": "aadya gupta",
        "phone": "8882698499",
        "age": 10,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Prateek Bansal",
        "childName": "Kiaan Bansal",
        "phone": "9891199280",
        "age": 5,
        "program": "Dance",
        "batch": "Mon",
        "days": "Mon",
        "time": "5:00 PM – 6:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Priyanka",
        "childName": "Arjun",
        "phone": "9901290814",
        "age": 9,
        "program": "Robotics",
        "batch": "Fri",
        "days": "Fri",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Priyanka",
        "childName": "Arjun",
        "phone": "9901290814",
        "age": 6,
        "program": "Dance",
        "batch": "Mon",
        "days": "Mon",
        "time": "5:00 PM – 6:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Rajni",
        "childName": "Navya Chaudhary",
        "phone": "7988071692",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Thurs",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Rajni",
        "childName": "Navya Chaudhary",
        "phone": "7988071692",
        "age": 9,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Rajni",
        "childName": "Navya Chaudhary",
        "phone": "7988071692",
        "age": 9,
        "program": "Dance",
        "batch": "Mon",
        "days": "Mon",
        "time": "6:15 PM – 7:15",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Rajni",
        "childName": "Aaryaveer Singh Chahal",
        "phone": "7988071692",
        "age": 6,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:00 PM – 1:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Rajni",
        "childName": "Navya Chaudhary",
        "phone": "7988071692",
        "age": 9,
        "program": "Robotics",
        "batch": "Fri",
        "days": "Fri",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Rashmita Shetty",
        "childName": "Shaira Shetty",
        "phone": "9902711998",
        "age": 6,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "12:00 PM – 1:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Rashmita Shetty",
        "childName": "Shaira Shetty",
        "phone": "9902711998",
        "age": 6,
        "program": "Dance",
        "batch": "Mon",
        "days": "Mon",
        "time": "5:00 PM – 6:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Rashmita Shetty",
        "childName": "Neil shetty",
        "phone": "9902711998",
        "age": 11,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Rashmita Shetty",
        "childName": "Neil shetty",
        "phone": "9902711998",
        "age": 11,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Ritu Somasekhar",
        "childName": "Atharv Rajeesh",
        "phone": "9886038365",
        "age": 7,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:00 PM – 1:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Sangeeta",
        "childName": "Reyansh",
        "phone": "8220988294",
        "age": 6,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "12:00 PM – 1:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Sanika Joshi",
        "childName": "Vivaan Jadhav",
        "phone": "9820195763",
        "age": 6,
        "program": "Robotics",
        "batch": "Fri",
        "days": "Fri",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Saurabh Pandey",
        "childName": "Saavi Pandey",
        "phone": "9740228554",
        "age": 7,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "12:00 PM – 1:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Sheeba Joseph",
        "childName": "Zaasha Zubin Matheikal",
        "phone": "9738023836",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Thurs",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Sheeba Joseph",
        "childName": "Zaasha Zubin Matheikal",
        "phone": "9738023836",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Sheeba Joseph",
        "childName": "Johan Zubin Matheikal",
        "phone": "9738023836",
        "age": 5,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:00 PM – 1:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Sheeba Joseph",
        "childName": "Johan Zubin Matheikal",
        "phone": "9738023836",
        "age": 5,
        "program": "Robotics",
        "batch": "Fri",
        "days": "Fri",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Sheeba Joseph",
        "childName": "Zaasha Zubin Matheikal",
        "phone": "9738023836",
        "age": 9,
        "program": "Dance",
        "batch": "Mon",
        "days": "Mon",
        "time": "6:15 PM – 7:15",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Smruthi Mudigal",
        "childName": "Devaditya Duvvur",
        "phone": "8861326229",
        "age": 5,
        "program": "Public Speaking",
        "batch": "Thurs",
        "days": "Thurs",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Sreelakshmi",
        "childName": "Sriram Sreekanth",
        "phone": "8590633520",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Sreelakshmi",
        "childName": "Sriram Sreekanth",
        "phone": "8590633520",
        "age": 9,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Suja George",
        "childName": "Kaira C James",
        "phone": "9980088677",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Thurs",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Thilaka",
        "childName": "Anirudh",
        "phone": "9962186272",
        "age": 8,
        "program": "Robotics",
        "batch": "Fri",
        "days": "Fri",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Thilaka",
        "childName": "Anirudh",
        "phone": "9962186272",
        "age": 8,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:00 PM – 1:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Vidhay u menmon",
        "childName": "neranjan",
        "phone": "9902236161",
        "age": 10,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Vidhay u menmon",
        "childName": "neranjan",
        "phone": "9902236161",
        "age": 10,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Vidhay u menmon",
        "childName": "gaytree",
        "phone": "9902236161",
        "age": 12,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      }
    ],
    "trials": [
      {
        "enquiryDate": "",
        "parentName": "Rimisha Raghavan",
        "childName": "Niyara Narayanan",
        "phone": "9986698506",
        "age": 8,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "Shantanu/Sounak",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": "DNP 2"
      },
      {
        "enquiryDate": "",
        "parentName": "Anushree Kanodia",
        "childName": "Avikaa luthra",
        "phone": "9818862436",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu/Sounak",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Nithya",
        "childName": "Advait",
        "phone": "8971968686",
        "age": 8,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Divya Singh",
        "childName": "Nihira",
        "phone": "9558703436",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Paridhi",
        "childName": "Nihira",
        "phone": "9819056096",
        "age": 6,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Murali Kumar",
        "childName": "Thanvi",
        "phone": "7618703380",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Call Back"
      },
      {
        "enquiryDate": "",
        "parentName": "Saurabh Pandey",
        "childName": "Saavi Pandey",
        "phone": "9740228554",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu/Harish",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Shalu Sharma",
        "childName": "Snehanshika Bhusan",
        "phone": "7411592133",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Sanmathi Rajesh",
        "childName": "Taushini Rajesh",
        "phone": "9448162266",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Vinaya",
        "childName": "Aradhana Anthony Raj",
        "phone": "9663801885",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu/vaibhav",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Radhika Tharuvara",
        "childName": "Bhadra R",
        "phone": "9964046790",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Chhavi",
        "childName": "Saanvi Jaiswal",
        "phone": "9742024234",
        "age": 11,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Chhavi",
        "childName": "Jaanvi Jaiswal",
        "phone": "9742024234",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Keerthi",
        "childName": "Samvit",
        "phone": "9901800927",
        "age": 12,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "NEHA MISRA",
        "childName": "AASHVI MISHRA",
        "phone": "9886484951",
        "age": 10,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "Shantanu/Sounak",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP 2"
      },
      {
        "enquiryDate": "",
        "parentName": "Meenu",
        "childName": "Maanvik Singh",
        "phone": "8884463337",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Bhumika",
        "childName": "Anika",
        "phone": "8660804579",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Pratik",
        "childName": "Akanksha Mehta",
        "phone": "9975024442",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP 2"
      },
      {
        "enquiryDate": "",
        "parentName": "Neha Kapoor",
        "childName": "Ahaana Gupta",
        "phone": "9901150245",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Indira",
        "childName": "Aarabhi",
        "phone": "9740247028",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Navaneeth Varma",
        "childName": "Kiara Varma",
        "phone": "9902470412",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "Shantanu/Sounak",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rimisha Raghavan",
        "childName": "Niyara Narayanan",
        "phone": "9986698506",
        "age": 8,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Anushree Kanodia",
        "childName": "Avikaa luthra",
        "phone": "9818862436",
        "age": 6,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu/Sounak",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Divya Singh",
        "childName": "Nihira",
        "phone": "9558703436",
        "age": 6,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Murali Kumar",
        "childName": "Thanvi",
        "phone": "7618703380",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Saurabh Pandey",
        "childName": "Saavi Pandey",
        "phone": "9740228554",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Not Interested"
      },
      {
        "enquiryDate": "",
        "parentName": "Pratik",
        "childName": "Akanksha Mehta",
        "phone": "9975024442",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Shalu Sharma",
        "childName": "Snehanshika Bhusan",
        "phone": "7411592133",
        "age": 7,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "NEHA MISRA",
        "childName": "AASHVI MISHRA",
        "phone": "9886484951",
        "age": 10,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "Shantanu/Sounak",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Ankita chhabra",
        "childName": "Ruhi bhambri",
        "phone": "9321394607",
        "age": 7,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Divya Singh",
        "childName": "Nihira",
        "phone": "9558703436",
        "age": 6,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Pratik",
        "childName": "Akanksha Mehta",
        "phone": "9975024442",
        "age": 9,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Asha Sandeep",
        "childName": "Anshika Musti",
        "phone": "9538048189",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Ankita chhabra",
        "childName": "Ruhi bhambri",
        "phone": "9321394607",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Sheeba Joseph",
        "childName": "Zaasha Zubin Matheikal",
        "phone": "9738023836",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "Shantanu",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Sheeba Joseph",
        "childName": "Zaasha Zubin Matheikal",
        "phone": "9738023836",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "Shantanu",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Sheeba Joseph",
        "childName": "Johan Zubin Matheikal",
        "phone": "9738023836",
        "age": 5,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "Shantanu",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Sheeba Joseph",
        "childName": "Johan Zubin Matheikal",
        "phone": "9738023836",
        "age": 5,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "Shantanu",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Priyanka",
        "childName": "Kaira",
        "phone": "9901290814",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "Shantanu",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Priyanka",
        "childName": "Kaira",
        "phone": "9901290814",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Priyanka",
        "childName": "Arjun kant",
        "phone": "9901290814",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Priyanka",
        "childName": "Arjun kant",
        "phone": "9901290814",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Vinod",
        "childName": "Pranav",
        "phone": "9886887899",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Ankita Chhabra",
        "childName": "Ruhi Bhambri",
        "phone": "9819147673",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Dipika Gupta",
        "childName": "Ishanvi Jha",
        "phone": "7411099686",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Sujata",
        "childName": "Divyansh",
        "phone": "9738044132",
        "age": 11,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Dipika Gupta",
        "childName": "Ishanvi Jha",
        "phone": "7411099686",
        "age": 6,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP 2"
      },
      {
        "enquiryDate": "",
        "parentName": "Sujata",
        "childName": "Divyansh",
        "phone": "9738044132",
        "age": 11,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP 2"
      },
      {
        "enquiryDate": "",
        "parentName": "Ashutosh Singh",
        "childName": "Evanya Singh",
        "phone": "9870600543",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "Shantanu/Sounak",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Thilaka",
        "childName": "Anirudh",
        "phone": "9962186272",
        "age": 8,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Thilaka",
        "childName": "Anirudh",
        "phone": "9962186272",
        "age": 8,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Smruthi Mudigal",
        "childName": "Devaditya Duvvur",
        "phone": "8861326229",
        "age": 5,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Vinod Raphael",
        "childName": "Pranav Vinod",
        "phone": "9886887899",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Julie Singh",
        "childName": "Meher Kaur Brar",
        "phone": "9902591002",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "Shanthanu/Harish",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Julie Singh",
        "childName": "Meher Kaur Brar",
        "phone": "99025 91002",
        "age": 6,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rahul agarwal",
        "childName": "Seeana agarwal",
        "phone": "9900097156",
        "age": 10,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rahul agarwal",
        "childName": "Seeana agarwal",
        "phone": "9900097156",
        "age": 10,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rahul agarwal",
        "childName": "Seeana agarwal",
        "phone": "9900097156",
        "age": 10,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Gautam Santosh",
        "childName": "Gautam Santosh",
        "phone": "9963144572",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "Shantanu",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": "DNP 2"
      },
      {
        "enquiryDate": "",
        "parentName": "Prateek Bansal",
        "childName": "Kiaan Bansal",
        "phone": "9891199280",
        "age": 5,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Navaneeth Varma",
        "childName": "Kiara Varma",
        "phone": "9902470412",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "Had a chat with of the managers but dosent know the name",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Suja George",
        "childName": "Kaira C James",
        "phone": "9980088677",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "Shantanu/Sounak",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Suja George",
        "childName": "Kaira C James",
        "phone": "9980088677",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "DNP",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Suja George",
        "childName": "Kaira C James",
        "phone": "9980088677",
        "age": 9,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Kaira Baid",
        "childName": "Kaira Baid",
        "phone": "9226395895",
        "age": 11,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP 2"
      },
      {
        "enquiryDate": "",
        "parentName": "Kaira Baid",
        "childName": "Kaira Baid",
        "phone": "9226395895",
        "age": 11,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Asha Sandeep",
        "childName": "Anshika Musti",
        "phone": "9538048189",
        "age": 9,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Asha Sandeep",
        "childName": "Anshika Musti",
        "phone": "9538048189",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "Not avaliable",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Ashutosh Singh",
        "childName": "Evanya Singh",
        "phone": "9870600543",
        "age": 5,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Julie singh",
        "childName": "Meher kaur",
        "phone": "9902591002",
        "age": 6,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "vaibhav",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Julie singh",
        "childName": "Meher kaur",
        "phone": "9902591002",
        "age": 6,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Navya Jain",
        "childName": "Navya Jain",
        "phone": "9731926543",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Navya Jain",
        "childName": "Navya Jain",
        "phone": "9731926543",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Prateek Bansal",
        "childName": "Kiaan Bansal",
        "phone": "9891199280",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Vidhay u menmon",
        "childName": "gaytree",
        "phone": "9902236161",
        "age": 12,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu/vaibhav",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": "DNP 3"
      },
      {
        "enquiryDate": "",
        "parentName": "Vidhay u menmon",
        "childName": "neranjan",
        "phone": "9902236161",
        "age": 10,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu/vaibhav",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP 3"
      },
      {
        "enquiryDate": "",
        "parentName": "Saurabh Pandey",
        "childName": "Saavi Pandey",
        "phone": "9740228554",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Krishna",
        "childName": "Adhvick",
        "phone": "9738450991",
        "age": 5,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Krishna",
        "childName": "Adhvick",
        "phone": "9738450991",
        "age": 5,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Krishna",
        "childName": "Adhvick",
        "phone": "9738450991",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Indra",
        "childName": "aarabhi",
        "phone": "9740247028",
        "age": 11,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "Shantanu/Vaibhav",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "hardik",
        "childName": "vatsal",
        "phone": "7259002266",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu/vaibhav",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Vidhay u menmon",
        "childName": "neranjan",
        "phone": "9902236161",
        "age": 10,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu/vaibhav",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": "DNP 3"
      },
      {
        "enquiryDate": "",
        "parentName": "Vidhay u menmon",
        "childName": "neranjan",
        "phone": "9902236161",
        "age": 10,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu/vaibhav",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Sheeba Joseph",
        "childName": "Zaasha Zubin Matheikal",
        "phone": "9738023836",
        "age": 9,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "Shantanu",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "sidharth",
        "childName": "Sanyan",
        "phone": "8527718822",
        "age": 8,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Attended",
        "followUpOwner": "Shantanu",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Sidharth",
        "childName": "Sanyan",
        "phone": "8527718822",
        "age": 8,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "Shantanu",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Pradeepa",
        "childName": "Takshvi",
        "phone": "9916146137",
        "age": 10,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "sounak",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Not Interested"
      },
      {
        "enquiryDate": "",
        "parentName": "Priyanka",
        "childName": "Arjun kant",
        "phone": "9901290814",
        "age": 7,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Vinaya",
        "childName": "Aradhana Anthony Raj",
        "phone": "9663801885",
        "age": 5,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu/vaibhav",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "hardik",
        "childName": "vatsal",
        "phone": "9986622260",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu/vaibhav",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Manjula",
        "childName": "Shrivanth",
        "phone": "9964541690",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": "DNP 2"
      },
      {
        "enquiryDate": "",
        "parentName": "Julie singh",
        "childName": "Meher kaur",
        "phone": "9902591002",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "vaibhav",
        "followUpDate": "",
        "converted": "NO",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Prateek Bansal",
        "childName": "Kiaan Bansal",
        "phone": "9891199280",
        "age": 5,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Smruthi Mudigal",
        "childName": "Devaditya Duvvur",
        "phone": "8861326229",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Ananda",
        "childName": "Adwait Mishra",
        "phone": "95382 00438",
        "age": 9,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Ananda",
        "childName": "Adwait Mishra",
        "phone": "95382 00438",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rajni",
        "childName": "Navya Chaudhary",
        "phone": "7988071692",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rajni",
        "childName": "Navya Chaudhary",
        "phone": "7988071692",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rajni",
        "childName": "Navya Chaudhary",
        "phone": "7988071692",
        "age": 9,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rajni",
        "childName": "Aaryaveer Singh Chahal",
        "phone": "7988071692",
        "age": 6,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rajni",
        "childName": "Navya Chaudhary",
        "phone": "7988071692",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Ritu Somasekhar",
        "childName": "Atharv Rajeesh",
        "phone": "9886038365",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Saurabh Pandey",
        "childName": "Saavi Pandey",
        "phone": "9740228554",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu/Harish",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Anushree Kanodia",
        "childName": "Avikaa luthra",
        "phone": "9818862436",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu/Sounak",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Priyanka",
        "childName": "Ronith",
        "phone": "9741514274",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Neha Kapoor",
        "childName": "Ahaana Gupta",
        "phone": "9901150245",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Neha Kapoor",
        "childName": "Ahaana Gupta",
        "phone": "9901150245",
        "age": 7,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "afisa",
        "childName": "",
        "phone": "88840 06661",
        "age": 11,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": "Connected - FUP"
      },
      {
        "enquiryDate": "",
        "parentName": "Priyanka",
        "childName": "Arjun",
        "phone": "9901290814",
        "age": 6,
        "program": "Dance",
        "trialDate": "2026-05-16",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Afshan Jabeen",
        "childName": "",
        "phone": "8884006661",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Keitaki Natu Agarwal",
        "childName": "Yajur Agarwal",
        "phone": "9871719746",
        "age": 5,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Neha Goyal",
        "childName": "Advay Agarwal",
        "phone": "9739360160",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Neha Goyal",
        "childName": "Advay Agarwal",
        "phone": "9739360160",
        "age": 9,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Ansul",
        "childName": "araya",
        "phone": "99163 88816",
        "age": 7,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Ansul",
        "childName": "anisha",
        "phone": "99163 88816",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Sreelakshmi",
        "childName": "Sriram Sreekanth",
        "phone": "8590633520",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Sreelakshmi",
        "childName": "Sriram Sreekanth",
        "phone": "8590633520",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-30",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rajni",
        "childName": "Navya Chaudhary",
        "phone": "7988071692",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rajni",
        "childName": "Navya Chaudhary",
        "phone": "7988071692",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rajni",
        "childName": "Aaryaveer Singh Chahal",
        "phone": "7988071692",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-30",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rajni",
        "childName": "Aaryaveer Singh Chahal",
        "phone": "7988071692",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Ananda Prava Dash",
        "childName": "Adwait Mishra",
        "phone": "9538200438",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Ananda Prava Dash",
        "childName": "Adwait Mishra",
        "phone": "9538200438",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Ananda Prava Dash",
        "childName": "Adwait Mishra",
        "phone": "9538200438",
        "age": 9,
        "program": "Dance",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Sanika Joshi",
        "childName": "Vivaan Jadhav",
        "phone": "9820195763",
        "age": 6,
        "program": "Robotics",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Aarti Shringarpure",
        "childName": "Ananya",
        "phone": "7738002465",
        "age": 11,
        "program": "Public Speaking",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rashmita Shetty",
        "childName": "Shaira Shetty",
        "phone": "9902711998",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rashmita Shetty",
        "childName": "Shaira Shetty",
        "phone": "9902711998",
        "age": 6,
        "program": "Dance",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Smruthi Mudigal",
        "childName": "Devaditya Duvvur",
        "phone": "8861326229",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Sangeeta",
        "childName": "Reyansh",
        "phone": "8220988294",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Jaicy",
        "childName": "Chris Thomas Joe",
        "phone": "8277123520",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Jaicy",
        "childName": "Chris Thomas Joe",
        "phone": "8277123520",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-30",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Heena",
        "childName": "Kyra Tayal",
        "phone": "9008102202",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Sandhya Misra",
        "childName": "Mishika Tiwari",
        "phone": "9840405423",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Preeti Gupta",
        "childName": "Himank Parida",
        "phone": "9989754353",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rashmita Shetty",
        "childName": "Shaira Shetty",
        "phone": "9902711998",
        "age": 5,
        "program": "Dance",
        "trialDate": "2026-05-30",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rashmita Shetty",
        "childName": "Neil shetty",
        "phone": "9902711998",
        "age": 11,
        "program": "Public Speaking",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Heena",
        "childName": "Kyra Tayal",
        "phone": "9008102202",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Sandhya Misra",
        "childName": "advay",
        "phone": "9840405423",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Sandhya Misra",
        "childName": "Mishika Tiwari",
        "phone": "9840405423",
        "age": 5,
        "program": "Robotics",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rashmita Shetty",
        "childName": "Neil shetty",
        "phone": "9902711998",
        "age": 11,
        "program": "Robotics",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "pooja",
        "childName": "aadya gupta",
        "phone": "8882698499",
        "age": 10,
        "program": "Robotics",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "pooja",
        "childName": "aadya gupta",
        "phone": "8882698499",
        "age": 10,
        "program": "Public Speaking",
        "trialDate": "2026-05-30",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Vishnu",
        "childName": "Anisha",
        "phone": "7760974565",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Vishnu",
        "childName": "Arya",
        "phone": "7760974565",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Afshan Jabeen",
        "childName": "Sara",
        "phone": "8884006661",
        "age": 11,
        "program": "Public Speaking",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Shyam",
        "childName": "Vedanth",
        "phone": "9900466440",
        "age": 6,
        "program": "Dance",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Astha",
        "childName": "Kiaan",
        "phone": "9654879862",
        "age": 5,
        "program": "Dance",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Afshan",
        "childName": "Adam",
        "phone": "8884006661",
        "age": 7,
        "program": "Dance",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rajni",
        "childName": "Navya Chaudhary",
        "phone": "7988071692",
        "age": 9,
        "program": "Dance",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Shayam",
        "childName": "Vedanth",
        "phone": "9900466440",
        "age": 11,
        "program": "Dance",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Afshan",
        "childName": "Adam",
        "phone": "8884006661",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Afshan Jabeen",
        "childName": "Sara",
        "phone": "8884006661",
        "age": 11,
        "program": "Robotics",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Priyanka",
        "childName": "Medhansh",
        "phone": "9538209228",
        "age": 10,
        "program": "Robotics",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Radhika Tharuvara",
        "childName": "Bhadra",
        "phone": "9964046790",
        "age": 6,
        "program": "Robotics",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Esha Gupta",
        "childName": "Aritro",
        "phone": "9731936040",
        "age": 6,
        "program": "Robotics",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Esha Gupta",
        "childName": "Aritro",
        "phone": "9731936040",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-05-30",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Mayur Vrushabhendra",
        "childName": "Ronith",
        "phone": "9972909192",
        "age": 9,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Mayur Vrushabhendra",
        "childName": "Ronith",
        "phone": "9972909192",
        "age": 9,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "rajesh Gopinath",
        "childName": "Riya Rajesh",
        "phone": "9900065449",
        "age": 9,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "YES",
        "callStatus": ""
      }
    ],
    "inventory": [
      {
        "item": "Robotics kit",
        "category": "Robotics",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 10,
        "received": 10,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Watch your step",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Tale trail",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Skill badge",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Stickers for dice",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 2,
        "received": 2,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Speech a palooza",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Guess me",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Body Talk",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Debate Duel",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Shuffle",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Train of thought",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Dice",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 6,
        "received": 6,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Meeples",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Pitch perfect",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Speaker",
        "category": "Dance",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Masking tape",
        "category": "Robotics",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Tokens",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 3,
        "received": 3,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Sharpener",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Timer",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Storage box",
        "category": "Robotics",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Soft ball",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Pen",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "White Charcoal pencils",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "Sign pen",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "What's that sound?",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "script flip",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": 1,
        "balance": "",
        "notes": ""
      },
      {
        "item": "dry erase marker",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 2,
        "received": 2,
        "balance": "",
        "notes": ""
      }
    ],
    "issues": [],
    "payout": {
      "sharePercent": 15,
      "accountDetails": "—",
      "rows": []
    },
    "payments": [
      {
        "parentName": "Navaneeth Varma",
        "children": "Kiara Varma",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_SqVDdQJ8j4krEO",
        "date": "2026-05-17",
        "phone": "919902470412"
      },
      {
        "parentName": "Meenu Singh",
        "children": "Maanvik Singh",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SqVVSicVd9NXyK",
        "date": "2026-05-17",
        "phone": "918884463337"
      },
      {
        "parentName": "Smruthi Mudigal",
        "children": "Devaditya Duvvur",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SqVXSOXbY2S3bC",
        "date": "2026-05-17",
        "phone": "918861326229"
      },
      {
        "parentName": "Ashutosh Singh",
        "children": "Evanya Singh",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SqVaPtKrmO8lWh",
        "date": "2026-05-17",
        "phone": "919870600543"
      },
      {
        "parentName": "Ritu Somasekhar",
        "children": "Atharv Rajeesh",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SqVhDuxrPqsDLS",
        "date": "2026-05-17",
        "phone": "919886038365"
      },
      {
        "parentName": "Sanmathi Rajesh",
        "children": "TAUSHINI RAJESH",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SqW00kPL01Vx5q",
        "date": "2026-05-17",
        "phone": "919448462266"
      },
      {
        "parentName": "Anushree Kanodia",
        "children": "Avikaa Luthra",
        "categories": "1 Category, twice/week + 1 Category, once/week",
        "month": "",
        "amount": 3825,
        "status": "Paid",
        "paymentId": "pay_SqeOy2MzeQTfK0",
        "date": "2026-05-18",
        "phone": "919818862436"
      },
      {
        "parentName": "Ananda Prava Dash",
        "children": "Adwait Mishra",
        "categories": "Dance (1 Hour. Once/Week)",
        "month": "",
        "amount": 1000,
        "status": "Paid",
        "paymentId": "pay_SqgkpDijwCy1cZ",
        "date": "2026-05-18",
        "phone": "919538200438"
      },
      {
        "parentName": "Ananda Prava Dash",
        "children": "Adwait Mishra",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SqgkpDijwCy1cZ",
        "date": "2026-05-18",
        "phone": "919538200438"
      },
      {
        "parentName": "Saurabh Pandey",
        "children": "Saavi Pandey",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_SqpIVPOAcDKJy8",
        "date": "2026-05-18",
        "phone": "919740228554"
      },
      {
        "parentName": "Radhika Tharuvara",
        "children": "Bhadra Ranjith",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SqqOxyPSAu8Ed7",
        "date": "2026-05-18",
        "phone": "919964046790"
      },
      {
        "parentName": "Rimisha Raghavan",
        "children": "Niyara Narayanan",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_SqsJwrWDvtE1rS",
        "date": "2026-05-18",
        "phone": "919986698506"
      },
      {
        "parentName": "Rajni Chahal",
        "children": "Navya & Aryaveer",
        "categories": "Dance + Robo + PS",
        "month": "",
        "amount": 5250,
        "status": "Paid",
        "paymentId": "",
        "date": "2026-05-18",
        "phone": "917988071692"
      },
      {
        "parentName": "Shalu Sharma",
        "children": "Snehanshika Bhusan",
        "categories": "Combination of 2 enrolments",
        "month": "",
        "amount": 2250,
        "status": "Paid",
        "paymentId": "pay_SqjbJLwYP4piPC",
        "date": "2026-05-18",
        "phone": "917411592133"
      },
      {
        "parentName": "Neha Kapoor",
        "children": "Ahaana Gupta",
        "categories": "Combination of 3 enrolments",
        "month": "",
        "amount": 3400,
        "status": "Paid",
        "paymentId": "pay_Sr4fGVGeI9wMIP",
        "date": "2026-05-19",
        "phone": "919901150245"
      },
      {
        "parentName": "Dr Chhavi",
        "children": "Jaanvi Jaiswal",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_Sr45hQlmnk0joy",
        "date": "2026-05-19",
        "phone": "919742024234"
      },
      {
        "parentName": "Dr Chhavi",
        "children": "Saanvi Jaiswal",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_Sr4CNereVju0YT",
        "date": "2026-05-19",
        "phone": "919742024234"
      },
      {
        "parentName": "Asha Sandeep musti",
        "children": "Anshika Musti",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_Sr4jbhR88cRS9x",
        "date": "2026-05-19",
        "phone": "919538048189"
      },
      {
        "parentName": "Asha Sandeep Musti",
        "children": "Anshika Musti",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_Sr4lzbLsvHnlGX",
        "date": "2026-05-19",
        "phone": "919538048189"
      },
      {
        "parentName": "Nithya Raman",
        "children": "Advait Makesh",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SrUkKTtYkZBphA",
        "date": "2026-05-20",
        "phone": "918971968686"
      },
      {
        "parentName": "NEHA MISRA",
        "children": "AASHVI MISHRA",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SrWddLbLhu0tSs",
        "date": "2026-05-20",
        "phone": "919886484951"
      },
      {
        "parentName": "prateek bansal",
        "children": "Kiaan Bansal",
        "categories": "Dance (1 Hour. Once/Week)",
        "month": "",
        "amount": 1000,
        "status": "Paid",
        "paymentId": "pay_SrZC1YsXSUvjrb",
        "date": "2026-05-20",
        "phone": "919891199280"
      },
      {
        "parentName": "Prajacta Modani",
        "children": "Vatsal",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_SrezeMkFqF4g4k",
        "date": "2026-05-20",
        "phone": "917259002266"
      },
      {
        "parentName": "Sheeba Joseph",
        "children": "Zaasha and Johan",
        "categories": "Combination of 5 enrolments",
        "month": "",
        "amount": 5250,
        "status": "Paid",
        "paymentId": "pay_Srx07qYJq4wqy4",
        "date": "2026-05-21",
        "phone": "919738023836"
      },
      {
        "parentName": "Suja george",
        "children": "Kaira Celine James",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_Ss10IgDEodZAGi",
        "date": "2026-05-21",
        "phone": "919980088677"
      },
      {
        "parentName": "Afshan Jabeen",
        "children": "Sara Mathew",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_Ss38meETcBrafO",
        "date": "2026-05-21",
        "phone": "918884006661"
      },
      {
        "parentName": "Thilaka Kannan",
        "children": "Anirudh Palaniappan",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1200,
        "status": "Paid",
        "paymentId": "pay_SsIvUQFnK8mg9q",
        "date": "2026-05-22",
        "phone": "919962186272"
      },
      {
        "parentName": "Keitaki Natu",
        "children": "Yajur Agarwal",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SsIIVRo11zxn4g",
        "date": "2026-05-22",
        "phone": "919871719746"
      },
      {
        "parentName": "Thilaka kannan",
        "children": "Anirudh Palaniappan",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SsIj5k90DoBupM",
        "date": "2026-05-22",
        "phone": "919962186272"
      },
      {
        "parentName": "Neha Goyal",
        "children": "Advay Agarwal",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_SsgMAtIT29vWyM",
        "date": "2026-05-23",
        "phone": "919739360160"
      },
      {
        "parentName": "Vidhya U menon",
        "children": "Gayathri m menon",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_StVWdr7pe9mM7P",
        "date": "2026-05-25",
        "phone": "919902236161"
      },
      {
        "parentName": "Vidhya U menon",
        "children": "Niranjan M Menon",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_StVXfxAZ9N0vCS",
        "date": "2026-05-25",
        "phone": "919902236161"
      },
      {
        "parentName": "Anshul Gupta",
        "children": "Arya and Anisha Nograhiya",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_StVn9sGhUYPZrS",
        "date": "2026-05-25",
        "phone": "919916388816"
      },
      {
        "parentName": "Ankita",
        "children": "Ruchi",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 4000,
        "status": "Paid",
        "paymentId": "pay_Sv6QY4YoRrHDT2",
        "date": "2026-05-29",
        "phone": "919321394607"
      },
      {
        "parentName": "pooja gupta",
        "children": "Aadya Gupta",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_SvCozzOmCElsVs",
        "date": "2026-05-29",
        "phone": "918882698499"
      },
      {
        "parentName": "Sangeeta Avinash",
        "children": "Reyansh avinash",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SvUB1IlLziJ7S1",
        "date": "2026-05-30",
        "phone": "918220988294"
      },
      {
        "parentName": "Esha Sen Gupta",
        "children": "Aritro Ganguli",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_SvXX6o6pchXFLQ",
        "date": "2026-05-30",
        "phone": "919731936040"
      },
      {
        "parentName": "Sandhya Misra",
        "children": "Mishika Tiwari Advay Tiwari",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_SvYEpo8SHIIM9M",
        "date": "2026-05-30",
        "phone": "919840405423"
      },
      {
        "parentName": "Sanika Joshi",
        "children": "Vivaan Jadhav",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SvZf7rAYEYx8Rx",
        "date": "2026-05-30",
        "phone": "919820195763"
      },
      {
        "parentName": "Ananda Prava Dash",
        "children": "Adwait Mishra",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 500,
        "status": "Paid",
        "paymentId": "pay_SvYOAEgbOt5jcl",
        "date": "2026-05-30",
        "phone": "919538200438"
      }
    ],
    "attendance": {
      "week": "Recent sessions",
      "dates": [],
      "rows": [
        {
          "childName": "Niyara Narayanan",
          "batch": "9986698506",
          "marks": []
        },
        {
          "childName": "Avikaa luthra",
          "batch": "9818862436",
          "marks": []
        },
        {
          "childName": "Advait",
          "batch": "8971968686",
          "marks": []
        },
        {
          "childName": "Saavi Pandey",
          "batch": "9740228554",
          "marks": []
        },
        {
          "childName": "Snehanshika Bhusan",
          "batch": "7411592133",
          "marks": []
        },
        {
          "childName": "Taushini",
          "batch": "9448162266",
          "marks": []
        },
        {
          "childName": "Bhadra R",
          "batch": "9964046790",
          "marks": []
        },
        {
          "childName": "Saanvi Jaiswal",
          "batch": "9742024234",
          "marks": []
        },
        {
          "childName": "Jaanvi Jaiswal",
          "batch": "9742024234",
          "marks": []
        },
        {
          "childName": "Maanvik Singh",
          "batch": "8884463337",
          "marks": []
        },
        {
          "childName": "Ahaana Gupta",
          "batch": "9901150245",
          "marks": []
        },
        {
          "childName": "Kiara Varma",
          "batch": "9902470412",
          "marks": []
        },
        {
          "childName": "Niyara Narayanan",
          "batch": "9986698506",
          "marks": []
        },
        {
          "childName": "Avikaa luthra",
          "batch": "9818862436",
          "marks": []
        }
      ]
    },
    "enrolmentOptions": {
      "families": [
        {
          "id": "f1",
          "name": "Rimisha Raghavan",
          "children": [
            "Niyara Narayanan"
          ]
        },
        {
          "id": "f2",
          "name": "Anushree Kanodia",
          "children": [
            "Avikaa luthra"
          ]
        },
        {
          "id": "f3",
          "name": "Nithya",
          "children": [
            "Advait"
          ]
        },
        {
          "id": "f4",
          "name": "Saurabh Pandey",
          "children": [
            "Saavi Pandey"
          ]
        },
        {
          "id": "f5",
          "name": "Shalu Sharma",
          "children": [
            "Snehanshika Bhusan"
          ]
        },
        {
          "id": "f6",
          "name": "Sanmathi Rajesh",
          "children": [
            "9448462266"
          ]
        },
        {
          "id": "f7",
          "name": "Radhika Tharuvara",
          "children": [
            "Bhadra R"
          ]
        },
        {
          "id": "f8",
          "name": "Chhavi",
          "children": [
            "Jaanvi Jaiswal",
            "Saanvi Jaiswal"
          ]
        },
        {
          "id": "f9",
          "name": "Meenu",
          "children": [
            "Maanvik Singh"
          ]
        },
        {
          "id": "f10",
          "name": "Neha Kapoor",
          "children": [
            "Ahaana Gupta"
          ]
        },
        {
          "id": "f11",
          "name": "Navaneeth Varma",
          "children": [
            "Kiara Varma"
          ]
        },
        {
          "id": "f12",
          "name": "Keitaki Natu Agarwal",
          "children": [
            "Yajur Agarwal"
          ]
        },
        {
          "id": "f13",
          "name": "Afshan Jabeen",
          "children": []
        },
        {
          "id": "f14",
          "name": "Ananda",
          "children": [
            "Adwait Mishra"
          ]
        },
        {
          "id": "f15",
          "name": "Ananda Prava Dash",
          "children": [
            "Adwait Mishra"
          ]
        },
        {
          "id": "f16",
          "name": "Ankita chhabra",
          "children": [
            "Ruhi bhambri"
          ]
        },
        {
          "id": "f17",
          "name": "Ansul",
          "children": [
            "anisha",
            "araya"
          ]
        },
        {
          "id": "f18",
          "name": "Asha Sandeep",
          "children": [
            "Anshika Musti"
          ]
        },
        {
          "id": "f19",
          "name": "Ashutosh Singh",
          "children": [
            "Evanya Singh"
          ]
        },
        {
          "id": "f20",
          "name": "Esha Gupta",
          "children": [
            "Aritro"
          ]
        },
        {
          "id": "f21",
          "name": "hardik",
          "children": [
            "vatsal"
          ]
        },
        {
          "id": "f22",
          "name": "Heena",
          "children": [
            "Kyra Tayal"
          ]
        },
        {
          "id": "f23",
          "name": "Mayur Vrushabhendra",
          "children": [
            "Ronith"
          ]
        },
        {
          "id": "f24",
          "name": "Neha Goyal",
          "children": [
            "Advay Agarwal"
          ]
        },
        {
          "id": "f25",
          "name": "NEHA MISRA",
          "children": [
            "AASHVI MISHRA"
          ]
        },
        {
          "id": "f26",
          "name": "pooja",
          "children": [
            "aadya gupta"
          ]
        },
        {
          "id": "f27",
          "name": "Prateek Bansal",
          "children": [
            "Kiaan Bansal"
          ]
        },
        {
          "id": "f28",
          "name": "Priyanka",
          "children": [
            "Arjun"
          ]
        },
        {
          "id": "f29",
          "name": "Rajni",
          "children": [
            "Aaryaveer Singh Chahal",
            "Navya Chaudhary"
          ]
        },
        {
          "id": "f30",
          "name": "Rashmita Shetty",
          "children": [
            "Neil shetty",
            "Shaira Shetty"
          ]
        },
        {
          "id": "f31",
          "name": "Ritu Somasekhar",
          "children": [
            "Atharv Rajeesh"
          ]
        },
        {
          "id": "f32",
          "name": "Sangeeta",
          "children": [
            "Reyansh"
          ]
        },
        {
          "id": "f33",
          "name": "Sanika Joshi",
          "children": [
            "Vivaan Jadhav"
          ]
        },
        {
          "id": "f34",
          "name": "Sheeba Joseph",
          "children": [
            "Johan Zubin Matheikal",
            "Zaasha Zubin Matheikal"
          ]
        },
        {
          "id": "f35",
          "name": "Smruthi Mudigal",
          "children": [
            "Devaditya Duvvur"
          ]
        },
        {
          "id": "f36",
          "name": "Sreelakshmi",
          "children": [
            "Sriram Sreekanth"
          ]
        },
        {
          "id": "f37",
          "name": "Suja George",
          "children": [
            "Kaira C James"
          ]
        },
        {
          "id": "f38",
          "name": "Thilaka",
          "children": [
            "Anirudh"
          ]
        },
        {
          "id": "f39",
          "name": "Vidhay u menmon",
          "children": [
            "gaytree",
            "neranjan"
          ]
        }
      ],
      "programs": [
        "Art",
        "Public Speaking",
        "Robotics",
        "Dance"
      ]
    },
    "dashboard": {
      "activeEnrolments": 74,
      "activeFamilies": 38,
      "trialsThisMonth": 161,
      "openIssues": 0,
      "revenueByMonth": [],
      "revenueByProgram": [
        {
          "program": "Public Speaking",
          "enrolments": 35,
          "revenue": 35000
        },
        {
          "program": "Robotics",
          "enrolments": 32,
          "revenue": 40000
        },
        {
          "program": "Dance",
          "enrolments": 7,
          "revenue": 7000
        }
      ],
      "attendance": {
        "present": 0,
        "absent": 0,
        "holiday": 0
      }
    }
  },
  "prestige-elysian": {
    "enrolments": [
      {
        "parentName": "Seema",
        "childName": "Ansh Gautam",
        "phone": "9740766639",
        "age": 7,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Seema",
        "childName": "Ansh Gautam",
        "phone": "9740766639",
        "age": 7,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Wed",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Mridu Gupta",
        "childName": "Nitiksha Agrawal",
        "phone": "9560909521",
        "age": 6,
        "program": "Robotics",
        "batch": "Robo 1",
        "days": "Fri",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Mridu Gupta",
        "childName": "Nitiksha Agrawal",
        "phone": "9560909521",
        "age": 6,
        "program": "Art",
        "batch": "Art 1",
        "days": "Thurs",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Manish Gupta",
        "childName": "Mishka Gupta",
        "phone": "9780033543",
        "age": 7,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Manish Gupta",
        "childName": "Mishka Gupta",
        "phone": "9780033543",
        "age": 7,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Wed",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Sree Mahalakshmi S",
        "childName": "Aditi Lakshmi Subramaniam",
        "phone": "9741781432",
        "age": 8,
        "program": "Robotics",
        "batch": "Robo 1",
        "days": "Fri",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Swetha",
        "childName": "Avyukt",
        "phone": "9986298312",
        "age": 9,
        "program": "Robotics",
        "batch": "Robo 2",
        "days": "Fri",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Vikash jain",
        "childName": "Mahir Jain",
        "phone": "9432200738",
        "age": 7,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Wed",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Vikash jain",
        "childName": "Mahir Jain",
        "phone": "9432200738",
        "age": 7,
        "program": "Robotics",
        "batch": "Robo 1",
        "days": "Fri",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Surabhee Nerurkar",
        "childName": "Jiza Ginde",
        "phone": "9731119106",
        "age": 6,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Surabhee Nerurkar",
        "childName": "Jiza Ginde",
        "phone": "9731119106",
        "age": 6,
        "program": "Robotics",
        "batch": "Robo 1",
        "days": "Tues",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Rakesh",
        "childName": "Saish",
        "phone": "9480003636",
        "age": 5,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Wed",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Aruna",
        "childName": "Sreeja Dande",
        "phone": "9353004380",
        "age": 10,
        "program": "Art",
        "batch": "Art 1",
        "days": "Thurs",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Sharan",
        "childName": "Caleb Ogirala",
        "phone": "9886309167",
        "age": 9,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Sharan",
        "childName": "Caleb Ogirala",
        "phone": "9886309167",
        "age": 9,
        "program": "Robotics",
        "batch": "Robo 2",
        "days": "Fri",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Sharat Atri",
        "childName": "Samvith Atri",
        "phone": "9886245963",
        "age": 10,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Wed",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Amritpal kaur",
        "childName": "Prabhkirat Singh",
        "phone": "8700146920",
        "age": 7,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Taruna Oberoi",
        "childName": "Viaan Bhatia",
        "phone": "9988845200",
        "age": 7,
        "program": "Robotics",
        "batch": "Robo 1",
        "days": "Tues",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Vivian",
        "childName": "Larren",
        "phone": "9845607953",
        "age": 5,
        "program": "Public Speaking",
        "batch": "PS 1",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Roopa Latha",
        "childName": "Pranav Kamath",
        "phone": "9900600681",
        "age": 11,
        "program": "Public Speaking",
        "batch": "PS 2",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      },
      {
        "parentName": "Priyanka",
        "childName": "Prisha",
        "phone": "9742454000",
        "age": 7,
        "program": "Art",
        "batch": "Art 1",
        "days": "Thurs",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "2026-06-01",
        "status": "Active"
      }
    ],
    "trials": [
      {
        "enquiryDate": "",
        "parentName": "Seema",
        "childName": "Ansh Gautam",
        "phone": "9740766639",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Imaad",
        "childName": "1",
        "phone": "9740984702",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Mridu Gupta",
        "childName": "Nitiksha Agrawal",
        "phone": "9560909521",
        "age": 6,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Mridu Gupta",
        "childName": "Nitiksha Agrawal",
        "phone": "9560909521",
        "age": 6,
        "program": "Art & Design",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Navneet Gautam",
        "childName": "Ansh Gautam",
        "phone": "9886463122",
        "age": 7,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Navneet Gautam",
        "childName": "Ansh Gautam",
        "phone": "9886463122",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Navneet Gautam",
        "childName": "Ansh Gautam",
        "phone": "9886463122",
        "age": 7,
        "program": "Art & Design",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Amritpal kaur",
        "childName": "Prabhkirat Singh",
        "phone": "8700146920",
        "age": 7,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Amritpal kaur",
        "childName": "Prabhkirat Singh",
        "phone": "8700146920",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rupam Shome",
        "childName": "Anindita Shome",
        "phone": "9742095606",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rupam Shome",
        "childName": "Anindita Shome",
        "phone": "9742095606",
        "age": 6,
        "program": "Art & Design",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Manish Gupta",
        "childName": "Mishka Gupta",
        "phone": "9780033543",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Manish Gupta",
        "childName": "Mishka Gupta",
        "phone": "9780033543",
        "age": 7,
        "program": "Art & Design",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Amit Goenka",
        "childName": "Prisha Goenka",
        "phone": "9620874353",
        "age": 8,
        "program": "Art & Design",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Amit Goenka",
        "childName": "Devyan Goenka",
        "phone": "9620874353",
        "age": 5,
        "program": "Art & Design",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Sree Mahalakshmi S",
        "childName": "Aditi Lakshmi Subramaniam",
        "phone": "9741781432",
        "age": 8,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Sree Mahalakshmi S",
        "childName": "Aditi Lakshmi Subramaniam",
        "phone": "9741781432",
        "age": 8,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Priyanka",
        "childName": "Saaransh",
        "phone": "9264453863",
        "age": 8,
        "program": "Another time slot",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Krishiv Kedia",
        "childName": "Krishiv Kedia",
        "phone": "9844515051",
        "age": 7,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rakesh",
        "childName": "Saish",
        "phone": "9480003636",
        "age": 5,
        "program": "Art & Design",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Vijay",
        "childName": "8",
        "phone": "9481779768",
        "age": 8,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Sharat Atri",
        "childName": "Samvith Atri",
        "phone": "9886245963",
        "age": 10,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Swetha",
        "childName": "Avyukt",
        "phone": "9986298312",
        "age": 9,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Swetha",
        "childName": "Avyukt",
        "phone": "9986298312",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Swetha",
        "childName": "Avyukt",
        "phone": "9986298312",
        "age": 9,
        "program": "Art & Design",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Sadanand",
        "childName": "Samarth",
        "phone": "9740569673",
        "age": 11,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Sadanand",
        "childName": "Samarth",
        "phone": "9740569673",
        "age": 11,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Sharan",
        "childName": "Caleb Ogirala",
        "phone": "9886309167",
        "age": 9,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Sharan",
        "childName": "Caleb Ogirala",
        "phone": "9886309167",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Vandhana",
        "childName": "Venba",
        "phone": "9632740351",
        "age": 11,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Gayathri R",
        "childName": "Tanvi Vijit Menon",
        "phone": "9886110383",
        "age": 9,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Gayathri R",
        "childName": "Tanvi Vijit Menon",
        "phone": "9886110383",
        "age": 9,
        "program": "Another time slot",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Vikash jain",
        "childName": "Mahir Jain",
        "phone": "9432200738",
        "age": 7,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Vikash jain",
        "childName": "Mahir Jain",
        "phone": "9432200738",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Vikash jain",
        "childName": "Mahir Jain",
        "phone": "9432200738",
        "age": 7,
        "program": "Art & Design",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Surabhee Nerurkar",
        "childName": "Jiza Ginde",
        "phone": "9731119106",
        "age": 6,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Attended",
        "followUpOwner": "Vaibhav",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Smriti",
        "childName": "Sheoli",
        "phone": "9535316541",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Priya",
        "childName": "Y Vihaan Reddy",
        "phone": "9845054149",
        "age": 10,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Priya",
        "childName": "Y.Ishaan Reddy",
        "phone": "9845054149",
        "age": 7,
        "program": "Art & Design",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Priya",
        "childName": "Y.Ishaan Reddy",
        "phone": "9845054149",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Timsi Kumari",
        "childName": "Nitara Kumar",
        "phone": "9051218478",
        "age": 5,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Priyanka",
        "childName": "Ayansh",
        "phone": "9742454000",
        "age": 11,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Priyanka",
        "childName": "Prisha",
        "phone": "9742454000",
        "age": 7,
        "program": "Art & Design",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rakesh",
        "childName": "Saish",
        "phone": "9480003636",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Attended",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Aruna",
        "childName": "Sreeja Dande",
        "phone": "9353004380",
        "age": 10,
        "program": "",
        "trialDate": "",
        "attendance": "Absent",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      }
    ],
    "inventory": [
      {
        "item": "Guess me",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Tale trail",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Watch your step",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "speech a palooza (WF)",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art Venture, Level 2",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Colour Flip",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Shape Fusion",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art Gym, level 3",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art Gym, level 4",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art Gym, level 5",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art Gym, Level 6",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art queue cards, Animals (B1)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art queue cards, Backgrounds",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art queue cards, Food",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Only for Trials",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art queue cards, Nature",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art queue cards, Vehicles",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art queue cards, Buildings",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art queue cards, Birds",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "A3 Papers - Black",
        "category": "Art",
        "capexOpex": "Opex",
        "purpose": "Regular",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Pipe Cleaners",
        "category": "Robotics",
        "capexOpex": "Capex",
        "purpose": "Regular",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Train of thought",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "What's that sound",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Body Talk",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Erasable markers",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": 10,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Tokens (1 Pack - Around !00 Pcs)",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "A4 sheets",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Soft ball",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Speaker",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Dice (4)",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Meeples (12)",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Clay",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Colour papers (100)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Glue stick (10)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": 10,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Erasers (20)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Sharpeners (20)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Aprons (12)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Water Jars (6)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Mystery Box",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Scissors (Set of 3)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Child Safe Scirssors",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Rulers (30 Cms)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Yarn",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Sequins",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Plastic Jars",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Tempera paint bottle set",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Pencils  - Faber castle Shading pencils",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Pencils  - Faber castle colour pencils - 24 shades",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Pastels - Oil pastels- 50 shades",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Pastels - Dry soft pastels",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Sketchpens - Domes Brush pens",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Paint Brushes",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Mixing Palettes",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Single hole Punching machine",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Debate Duel",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Large Palette",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Round Brush Set",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art Book",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Logo front sheet",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Fevicol",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Texture sheets",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Pipe cleaners (100 Pcs)",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "A3 Sheets",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Roving wool (Pink, blue, green)",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Acrylic Paint",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Script Flip",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Regular",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Body Talk",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Shuffle",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Spaggle",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Acrylic Paint 500 ml white colour",
        "category": "",
        "capexOpex": "Capex",
        "purpose": "",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      }
    ],
    "issues": [],
    "payout": {
      "sharePercent": 15,
      "accountDetails": "—",
      "rows": [
        {
          "month": "June '26",
          "totalRev": 31200,
          "apartmentShare": 4680.0,
          "paid": false,
          "netTotal": 26440.68,
          "netApartment": 3966.1,
          "notes": ""
        }
      ]
    },
    "payments": [
      {
        "parentName": "Sree Mahalakshmi S",
        "children": "Aditi Lakshmi Subramaniam",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SskYWx1MEhks45",
        "date": "2026-05-23",
        "phone": "919741781432"
      },
      {
        "parentName": "Mridu Gupta",
        "children": "Nitiksha Agrawal",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_St47wOzNomRGcF",
        "date": "2026-05-24",
        "phone": "919560909521"
      },
      {
        "parentName": "Navneet Gautam",
        "children": "Ansh Gautam",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_St5WPZJ2C7YFNp",
        "date": "2026-05-24",
        "phone": "919740766639"
      },
      {
        "parentName": "Vikash jain",
        "children": "Mahir Jain",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_Stpt1ZnOksAnKC",
        "date": "2026-05-26",
        "phone": "919432200738"
      },
      {
        "parentName": "Surabhee Nerurkar",
        "children": "Jiza Ginde",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_Su4UF9q4V22Klw",
        "date": "2026-05-26",
        "phone": "919731119106"
      },
      {
        "parentName": "swetha Manjunath",
        "children": "Avyukt Achal",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_Sv3benqHgLxlie",
        "date": "2026-05-29",
        "phone": "919986298312"
      },
      {
        "parentName": "Rakesh Prabhu",
        "children": "Saish Prabhu",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_Sv5Gm4TTN9DDnN",
        "date": "2026-05-29",
        "phone": "919480003636"
      },
      {
        "parentName": "Manish Gupta",
        "children": "Mishka Gupta",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_Sv7DHhCGlLYwJh",
        "date": "2026-05-29",
        "phone": "919780033543"
      },
      {
        "parentName": "Aruna",
        "children": "Sreeja Dande",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SvU0SKz4NNTsR6",
        "date": "2026-05-30",
        "phone": "919353004380"
      },
      {
        "parentName": "Sharan Fernandes",
        "children": "Caleb Ogirala",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_SvXlqYbrrD3oxn",
        "date": "2026-05-30",
        "phone": "919886309167"
      },
      {
        "parentName": "Sharat Atri",
        "children": "Samvith Atri",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SwDHw2baiuwg1I",
        "date": "2026-06-01",
        "phone": "919886245963"
      },
      {
        "parentName": "Amritpal Kaur",
        "children": "Prabhkirat Singh",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SwE4jdLUXybweD",
        "date": "2026-06-01",
        "phone": "918700146920"
      },
      {
        "parentName": "Vivian Dsouza",
        "children": "Larren D Souza",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SwkAHPHzEJPPVm",
        "date": "2026-06-02",
        "phone": "919845607953"
      },
      {
        "parentName": "Taruna",
        "children": "Viaan Bhatia",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_Swlb8jEwJE36iZ",
        "date": "2026-06-02",
        "phone": "919988845200"
      },
      {
        "parentName": "Roopalatha Shenoy",
        "children": "Pranav Kamath",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SwqIn6hRPXXFve",
        "date": "2026-06-02",
        "phone": "919900600681"
      },
      {
        "parentName": "Priyanka Rani",
        "children": "Prisha Sahu",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_Sx455AIIFQG8EH",
        "date": "2026-06-03",
        "phone": "919742454000"
      }
    ],
    "attendance": {
      "week": "Recent sessions",
      "dates": [
        "2026-06-01",
        "2026-06-02",
        "2026-06-03",
        "2026-06-04",
        "2026-06-05"
      ],
      "rows": [
        {
          "childName": "Ansh Gautam",
          "batch": "PS 1",
          "marks": [
            "P",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Ansh Gautam",
          "batch": "PS 1",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Nitiksha Agrawal",
          "batch": "Robo 1",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Nitiksha Agrawal",
          "batch": "Art 1",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Mishka Gupta",
          "batch": "PS 1",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Mishka Gupta",
          "batch": "PS 1",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Aditi Lakshmi Subramaniam",
          "batch": "Robo 1",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Avyukt",
          "batch": "Robo 2",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Mahir Jain",
          "batch": "PS 1",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Mahir Jain",
          "batch": "Robo 1",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Jiza Ginde",
          "batch": "PS 1",
          "marks": [
            "P",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Jiza Ginde",
          "batch": "Robo 1",
          "marks": [
            "",
            "P",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Saish",
          "batch": "PS 1",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        },
        {
          "childName": "Sreeja Dande",
          "batch": "Art 1",
          "marks": [
            "",
            "",
            "",
            "",
            ""
          ]
        }
      ]
    },
    "enrolmentOptions": {
      "families": [
        {
          "id": "f1",
          "name": "Seema",
          "children": [
            "Ansh Gautam"
          ]
        },
        {
          "id": "f2",
          "name": "Mridu Gupta",
          "children": [
            "Nitiksha Agrawal"
          ]
        },
        {
          "id": "f3",
          "name": "Manish Gupta",
          "children": [
            "Mishka Gupta"
          ]
        },
        {
          "id": "f4",
          "name": "Sree Mahalakshmi S",
          "children": [
            "Aditi Lakshmi Subramaniam"
          ]
        },
        {
          "id": "f5",
          "name": "Swetha",
          "children": [
            "Avyukt"
          ]
        },
        {
          "id": "f6",
          "name": "Vikash jain",
          "children": [
            "Mahir Jain"
          ]
        },
        {
          "id": "f7",
          "name": "Surabhee Nerurkar",
          "children": [
            "Jiza Ginde"
          ]
        },
        {
          "id": "f8",
          "name": "Rakesh",
          "children": [
            "Saish"
          ]
        },
        {
          "id": "f9",
          "name": "Aruna",
          "children": [
            "Sreeja Dande"
          ]
        },
        {
          "id": "f10",
          "name": "Sharan",
          "children": [
            "Caleb Ogirala"
          ]
        },
        {
          "id": "f11",
          "name": "Sharat Atri",
          "children": [
            "Samvith Atri"
          ]
        },
        {
          "id": "f12",
          "name": "Amritpal kaur",
          "children": [
            "Prabhkirat Singh"
          ]
        },
        {
          "id": "f13",
          "name": "Taruna Oberoi",
          "children": [
            "Viaan Bhatia"
          ]
        },
        {
          "id": "f14",
          "name": "Vivian",
          "children": [
            "Larren"
          ]
        },
        {
          "id": "f15",
          "name": "Roopa Latha",
          "children": [
            "Pranav Kamath"
          ]
        },
        {
          "id": "f16",
          "name": "Priyanka",
          "children": [
            "Prisha"
          ]
        }
      ],
      "programs": [
        "Art",
        "Public Speaking",
        "Robotics",
        "Dance"
      ]
    },
    "dashboard": {
      "activeEnrolments": 22,
      "activeFamilies": 16,
      "trialsThisMonth": 45,
      "openIssues": 0,
      "revenueByMonth": [
        {
          "month": "June '26",
          "revenue": 31200,
          "apartmentShare": 4680.0,
          "paid": false
        }
      ],
      "revenueByProgram": [
        {
          "program": "Public Speaking",
          "enrolments": 12,
          "revenue": 12000
        },
        {
          "program": "Robotics",
          "enrolments": 7,
          "revenue": 8750
        },
        {
          "program": "Art",
          "enrolments": 3,
          "revenue": 3000
        }
      ],
      "attendance": {
        "present": 3,
        "absent": 0,
        "holiday": 0
      }
    }
  },
  "prestige-waterford": {
    "enrolments": [
      {
        "parentName": "Arthi",
        "childName": "Rithwik",
        "phone": "7406206111",
        "age": 10,
        "program": "Robotics",
        "batch": "Sun",
        "days": "Sun",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Arthi",
        "childName": "Rithanya",
        "phone": "7406206111",
        "age": 8,
        "program": "Public Speaking",
        "batch": "Sat",
        "days": "Sat",
        "time": "9:00 AM - 10:30 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Arthi",
        "childName": "Rithanya",
        "phone": "7406206111",
        "age": 8,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Arya",
        "childName": "Shambhavi",
        "phone": "8897413742",
        "age": 7,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:30 PM – 2:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Arya",
        "childName": "Shambhavi",
        "phone": "8897413742",
        "age": 7,
        "program": "Public Speaking",
        "batch": "Mon",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Kinnari",
        "childName": "Kimaya",
        "phone": "9004299299",
        "age": 7,
        "program": "Public Speaking",
        "batch": "Mon",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Mayur Agrawal",
        "childName": "Vivaan Agrawal",
        "phone": "9986516272",
        "age": 5,
        "program": "Public Speaking",
        "batch": "Sat",
        "days": "Sat",
        "time": "10:30 AM - 12:00 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Mayur Agrawal",
        "childName": "Vivaan Agrawal",
        "phone": "9986516272",
        "age": 5,
        "program": "Robotics",
        "batch": "Sun",
        "days": "Sun",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Neha Agarwal",
        "childName": "Vihaan Agarwal",
        "phone": "9997166247",
        "age": 7,
        "program": "Public Speaking",
        "batch": "Mon",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Neha Agarwal",
        "childName": "Reyansh Agarwal",
        "phone": "9997166247",
        "age": 11,
        "program": "Public Speaking",
        "batch": "Sat",
        "days": "Sat",
        "time": "9:00 AM - 10:30 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Neha Agarwal",
        "childName": "Reyansh Agarwal",
        "phone": "9997166247",
        "age": 11,
        "program": "Public Speaking",
        "batch": "Mon",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Neha Agarwal",
        "childName": "Vihaan Agarwal",
        "phone": "9997166247",
        "age": 7,
        "program": "Dance",
        "batch": "Sat",
        "days": "Sat",
        "time": "4:00 PM – 5:00 PM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Neha Roy",
        "childName": "Veeraj Roy",
        "phone": "7709739177",
        "age": 7,
        "program": "Public Speaking",
        "batch": "Mon",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Nishant Paliwal(OH )",
        "childName": "Natasha Paliwal",
        "phone": "9901685027",
        "age": 6,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "10:30 AM - 12:00 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Nishant Paliwal(OH )",
        "childName": "Natasha Paliwal",
        "phone": "9901685027",
        "age": 6,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:30 PM – 2:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Pallavi Chaudhary",
        "childName": "Atharv Nehra",
        "phone": "8884751418",
        "age": 8,
        "program": "Public Speaking",
        "batch": "Mon",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Pallavi Chaudhary",
        "childName": "Atharv Nehra",
        "phone": "8884751418",
        "age": 8,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:30 PM – 2:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Pooja parmar",
        "childName": "Ahaan Negi",
        "phone": "7738204980",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Mon",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Praanshu Gupta",
        "childName": "Anaisha Fupta",
        "phone": "9818966918",
        "age": 6,
        "program": "Public Speaking",
        "batch": "Sat",
        "days": "Sat",
        "time": "10:30 AM - 12:00 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Praanshu Gupta",
        "childName": "Anaisha Fupta",
        "phone": "9818966918",
        "age": 6,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:30 PM – 2:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Pushkar",
        "childName": "Armaan Sinha",
        "phone": "9916203363",
        "age": 7,
        "program": "Robotics",
        "batch": "Sun",
        "days": "Sun",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Rahul",
        "childName": "Kiara",
        "phone": "9899989419",
        "age": 8,
        "program": "Public Speaking",
        "batch": "Mon",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Ramya",
        "childName": "Nitara",
        "phone": "9742476258",
        "age": 7,
        "program": "Public Speaking",
        "batch": "Sat",
        "days": "Sat",
        "time": "10:30 AM - 12:00 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Aditya",
        "childName": "Sathvika",
        "phone": "9632968587",
        "age": 9,
        "program": "Robotics",
        "batch": "Sun",
        "days": "Sun",
        "time": "12:30 PM – 2:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Namrata",
        "childName": "Reyaansh",
        "phone": "9650611776",
        "age": 7,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:30 PM – 2:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Namrata",
        "childName": "Reyaansh",
        "phone": "9650611776",
        "age": 7,
        "program": "Robotics",
        "batch": "Sun",
        "days": "Sun",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Namrata",
        "childName": "Adya",
        "phone": "9650611776",
        "age": 9,
        "program": "Robotics",
        "batch": "Sun",
        "days": "Sun",
        "time": "12:30 PM – 2:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Namrata",
        "childName": "Adya",
        "phone": "9650611776",
        "age": 9,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Nidhi Kaushal(OH)",
        "childName": "Raghav Kumar",
        "phone": "9845529581",
        "age": 6,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:30 PM – 2:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Monisha",
        "childName": "Gianna Niya Machamada",
        "phone": "9886654520",
        "age": 9,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Monisha",
        "childName": "Gianna Niya Machamada",
        "phone": "9886654520",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Mon",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Rahul",
        "childName": "Kiara",
        "phone": "9899989419",
        "age": 8,
        "program": "Public Speaking",
        "batch": "Sat",
        "days": "Sat",
        "time": "10:30 AM - 12:00 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Charu",
        "childName": "Sayesha",
        "phone": "9986363988",
        "age": 7,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Charu",
        "childName": "Sayesha",
        "phone": "9986363988",
        "age": 7,
        "program": "Public Speaking",
        "batch": "Mon",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Kinnari",
        "childName": "Kimaya",
        "phone": "9004299299",
        "age": 7,
        "program": "Public Speaking",
        "batch": "Sat",
        "days": "Sat",
        "time": "10:30 AM - 12:00 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Pavitra",
        "childName": "Varsha",
        "phone": "9916001937",
        "age": 11,
        "program": "Robotics",
        "batch": "Sun",
        "days": "Sun",
        "time": "12:30 PM – 2:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Kunjal",
        "childName": "Hetvik",
        "phone": "9821086805",
        "age": 7,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "10:30 AM - 12:00 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Kunjal",
        "childName": "Hetvik",
        "phone": "9821086805",
        "age": 7,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:30 PM – 2:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Pavitra",
        "childName": "Aarav",
        "phone": "9916001937",
        "age": 11,
        "program": "Robotics",
        "batch": "Sun",
        "days": "Sun",
        "time": "12:30 PM – 2:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Pooja parmar",
        "childName": "Ahaan Negi",
        "phone": "7738204980",
        "age": 9,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Namrata",
        "childName": "Reyaansh",
        "phone": "9650611776",
        "age": 7,
        "program": "Public Speaking",
        "batch": "Sat",
        "days": "Sat",
        "time": "10:30 AM - 12:00 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Namrata",
        "childName": "Reyaansh",
        "phone": "9650611776",
        "age": 7,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "10:30 AM - 12:00 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Namrata",
        "childName": "Adya",
        "phone": "9650611776",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "9:00 AM - 10:30 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Namrata",
        "childName": "Adya",
        "phone": "9650611776",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Sat",
        "days": "Sat",
        "time": "9:00 AM - 10:30 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Rosana",
        "childName": "Ruvika",
        "phone": "9620901159",
        "age": 5,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:30 PM – 2:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Pavitra",
        "childName": "Varsha",
        "phone": "9916001937",
        "age": 11,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Pavitra",
        "childName": "Aarav",
        "phone": "9916001937",
        "age": 11,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Naavya Jadhav",
        "childName": "Shrirang Jadhav",
        "phone": "8050005696",
        "age": 7,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:30 PM – 2:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Simrat",
        "childName": "Siddharth",
        "phone": "9884297398",
        "age": 5,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "12:30 PM – 2:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Simrat",
        "childName": "Siddharth",
        "phone": "9884297398",
        "age": 5,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "10:30 AM - 12:00 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Monisha",
        "childName": "Gianna Niya Machamada",
        "phone": "9886654520",
        "age": 9,
        "program": "Robotics",
        "batch": "Sun",
        "days": "Sun",
        "time": "12:30 PM – 2:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Monisha",
        "childName": "Gianna Niya Machamada",
        "phone": "9886654520",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Sat",
        "days": "Sat",
        "time": "9:00 AM - 10:30 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Kriti Jain",
        "childName": "Mayeem",
        "phone": "9916899920",
        "age": 7,
        "program": "Public Speaking",
        "batch": "Mon",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Kriti Jain",
        "childName": "Mayeem",
        "phone": "9916899920",
        "age": 7,
        "program": "Robotics",
        "batch": "Sun",
        "days": "Sun",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Kriti Jain",
        "childName": "Mandana Diwakar",
        "phone": "9916899920",
        "age": 7,
        "program": "Public Speaking",
        "batch": "Mon",
        "days": "Mon",
        "time": "4:30-6",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Kriti Jain",
        "childName": "Mandana Diwakar",
        "phone": "9916899920",
        "age": 7,
        "program": "Robotics",
        "batch": "Sun",
        "days": "Sun",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Prashant Oberoi",
        "childName": "Kabir",
        "phone": "8147881532",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Sat",
        "days": "Sat",
        "time": "9:00 AM - 10:30 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Prashant Oberoi",
        "childName": "Kabir",
        "phone": "8147881532",
        "age": 9,
        "program": "Public Speaking",
        "batch": "Mon",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Prashant Oberoi",
        "childName": "Kabir",
        "phone": "8147881532",
        "age": 9,
        "program": "Robotics",
        "batch": "Sat",
        "days": "Sat",
        "time": "2:30 PM – 4:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Prashant Oberoi",
        "childName": "Kabir",
        "phone": "8147881532",
        "age": 9,
        "program": "Robotics",
        "batch": "Sun",
        "days": "Sun",
        "time": "12:30 PM – 2:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Srilakshmi T",
        "childName": "Sathvika T",
        "phone": "9663645566",
        "age": 6,
        "program": "Public Speaking",
        "batch": "Mon",
        "days": "Mon",
        "time": "6-7:30",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Mayur Agrawal",
        "childName": "Vivaan Agrawal",
        "phone": "9986516272",
        "age": 5,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "10:30 AM - 12:00 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Ruby shah Yadav",
        "childName": "Lakshya",
        "phone": "6362308757",
        "age": 8,
        "program": "Public Speaking",
        "batch": "Sat",
        "days": "Sat",
        "time": "10:30 AM - 12:00 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "ruby shah Yadav",
        "childName": "Lakshya",
        "phone": "6362308757",
        "age": 8,
        "program": "Robotics",
        "batch": "Sun",
        "days": "Sun",
        "time": "12:30 PM – 2:00",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      },
      {
        "parentName": "Sreedevi",
        "childName": "Ameya",
        "phone": "9739885358",
        "age": 11,
        "program": "Public Speaking",
        "batch": "Sun",
        "days": "Sun",
        "time": "9:00 AM - 10:30 AM",
        "frequency": "1x",
        "joinDate": "",
        "status": "Active"
      }
    ],
    "trials": [
      {
        "enquiryDate": "",
        "parentName": "Arthi",
        "childName": "Rithwik",
        "phone": "7406206111",
        "age": 10,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Aditya",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Arthi",
        "childName": "Rithanya",
        "phone": "7406206111",
        "age": 8,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Aditya",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Arthi",
        "childName": "Rithanya",
        "phone": "7406206111",
        "age": 8,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Aditya",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Arya",
        "childName": "Shambhavi",
        "phone": "8897413742",
        "age": 7,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "No",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Arya",
        "childName": "Shambhavi",
        "phone": "8897413742",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Shantanu/Sounak",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Arya",
        "childName": "Shambhavi",
        "phone": "8897413742",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Shantanu/Sounak",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Asit Pradhan",
        "childName": "Riona",
        "phone": "9885192100",
        "age": 10,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Asit Pradhan",
        "childName": "Riona",
        "phone": "9885192100",
        "age": 10,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Bhavini",
        "childName": "Hridaan",
        "phone": "9702099655",
        "age": 10,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Bhavini",
        "childName": "Mishika",
        "phone": "9702099655",
        "age": 8,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Bhavini",
        "childName": "Hridhaan",
        "phone": "9702099655",
        "age": 10,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Bhavini",
        "childName": "Hridaan",
        "phone": "9702099655",
        "age": 10,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Bhavini",
        "childName": "Mishika",
        "phone": "9702099655",
        "age": 8,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Bhavini",
        "childName": "Mishika",
        "phone": "9702099655",
        "age": 8,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "No",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Dharmendra Kumar Mishra",
        "childName": "Krishang Mishra",
        "phone": "9740997590",
        "age": 5,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "No",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Dharmendra Kumar Mishra",
        "childName": "Krishang Mishra",
        "phone": "9740997590",
        "age": 5,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "No",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Kinnari",
        "childName": "Kimaya",
        "phone": "9004299299",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Shantanu",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Kriti Jain",
        "childName": "Mayeem",
        "phone": "9916899920",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Kriti Jain",
        "childName": "Mayeem",
        "phone": "9916899920",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Kriti Jain",
        "childName": "Mandana Diwakar",
        "phone": "9916899920",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Kriti Jain",
        "childName": "Mandana Diwakar",
        "phone": "9916899920",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Kriti Pandey",
        "childName": "Yuvaan Barthwal",
        "phone": "9599945082",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Margaret K",
        "childName": "Kathryn Kingston",
        "phone": "8123247926",
        "age": 9,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Mayur Agrawal",
        "childName": "Vivaan",
        "phone": "9986516272",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Mayur Agrawal",
        "childName": "Vivaan Agrawal",
        "phone": "9986516272",
        "age": 5,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Navyavani Devisetti",
        "childName": "Jiyanshi GV",
        "phone": "8121392596",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP 2"
      },
      {
        "enquiryDate": "",
        "parentName": "Navyavani Devisetti",
        "childName": "Jiyanshi GV",
        "phone": "8121392596",
        "age": 6,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP 2"
      },
      {
        "enquiryDate": "",
        "parentName": "Neha Agarwal",
        "childName": "Vihaan Agarwal",
        "phone": "9997166247",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Neha Agarwal",
        "childName": "Reyansh Agarwal",
        "phone": "9997166247",
        "age": 11,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Neha Agarwal",
        "childName": "Reyansh Agarwal",
        "phone": "9997166247",
        "age": 11,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Neha Agarwal",
        "childName": "Vihaan Agarwal",
        "phone": "9997166247",
        "age": 7,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Neha Khatri",
        "childName": "Nirvaan",
        "phone": "7676850380",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Neha Khatri",
        "childName": "Nirvaan",
        "phone": "7676850380",
        "age": 7,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "No",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Neha Khatri",
        "childName": "Nirvaan Srivastav",
        "phone": "7676850380",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Neha Roy",
        "childName": "Veeraj Roy",
        "phone": "7709739177",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Neha Roy",
        "childName": "Veeraj Roy",
        "phone": "7709739177",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Aditya",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Nishant Paliwal(OH )",
        "childName": "Natasha Paliwal",
        "phone": "9901685027",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "No",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Nishant Paliwal",
        "childName": "Natasha Paliwal",
        "phone": "9901685027",
        "age": 6,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "No",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Nishant Paliwal(OH )",
        "childName": "Natasha Paliwal",
        "phone": "9901685027",
        "age": 6,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "No",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Pallavi Chaudhary",
        "childName": "Atharv Nehra",
        "phone": "8884751418",
        "age": 8,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Aditya",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Pallavi Chaudhary",
        "childName": "Atharv Nehra",
        "phone": "8884751418",
        "age": 8,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Aditya",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Pooja parmar",
        "childName": "Ahaan Negi",
        "phone": "7738204980",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Praanshu Gupta",
        "childName": "Anaisha Fupta",
        "phone": "9818966918",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Praanshu Gupta",
        "childName": "Anaisha Fupta",
        "phone": "9818966918",
        "age": 6,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Praanshu Gupta",
        "childName": "Anaisha Fupta",
        "phone": "9818966918",
        "age": 6,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Priya Rai",
        "childName": "Kanishk Sharma",
        "phone": "9611211223",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Priya Rai",
        "childName": "Kanishk Sharma",
        "phone": "9611211223",
        "age": 6,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Priyanka",
        "childName": "Kriday",
        "phone": "9535099767",
        "age": 11,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Pushkar",
        "childName": "Armaan Sinha",
        "phone": "9916203363",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Aditya",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Pushkar",
        "childName": "Armaan Sinha",
        "phone": "9916203363",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Aditya",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rahul",
        "childName": "Kiara",
        "phone": "9899989419",
        "age": 8,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rahul",
        "childName": "kinnari",
        "phone": "9899989419",
        "age": 8,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Ramya",
        "childName": "Nitara",
        "phone": "9742476258",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Shantanu",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Ramya",
        "childName": "Nitara",
        "phone": "9742476258",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Aditya",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Aditya",
        "childName": "Sathvika",
        "phone": "9632968587",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rosanna",
        "childName": "Ruvika",
        "phone": "9620901159",
        "age": 5,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Aditya",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Rosanna",
        "childName": "Ruvika",
        "phone": "9620901159",
        "age": 5,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP 2"
      },
      {
        "enquiryDate": "",
        "parentName": "Ruby shah Yadav",
        "childName": "Lakshya",
        "phone": "6362308757",
        "age": 8,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "ruby shah Yadav",
        "childName": "Lakshya",
        "phone": "6362308757",
        "age": 8,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Saivakami",
        "childName": "Sarvesh",
        "phone": "9620466689",
        "age": 12,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Simran",
        "childName": "Avyaan Goyal",
        "phone": "9538910940",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Shantanu/Sounak",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Simran",
        "childName": "Avyaan Goyal",
        "phone": "9538910940",
        "age": 5,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Simran",
        "childName": "Avyaan Goyal",
        "phone": "9538910940",
        "age": 5,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Shantanu/Sounak",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Sirisha",
        "childName": "Dhruveen",
        "phone": "9731563511",
        "age": 4,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "No",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Sreedevi",
        "childName": "Ameya",
        "phone": "9739885358",
        "age": 11,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "No",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP 2"
      },
      {
        "enquiryDate": "",
        "parentName": "Sreedevi",
        "childName": "Ameya",
        "phone": "9739885358",
        "age": 11,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": "DNP 2"
      },
      {
        "enquiryDate": "",
        "parentName": "Srilakshmi T",
        "childName": "Sathvika T",
        "phone": "9663645566",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Srilakshmi T",
        "childName": "Sathvika T",
        "phone": "9663645566",
        "age": 6,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Srilakshmi T",
        "childName": "Sathvika T",
        "phone": "9663645566",
        "age": 6,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "No",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Surekha Goyal",
        "childName": "Vivaan",
        "phone": "9845067928",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Aditya",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Suryaditya",
        "childName": "Nivanshi",
        "phone": "9920380175",
        "age": 6,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "No",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "No",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Vineeta Verma",
        "childName": "Samarth Verma",
        "phone": "9902925867",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP 2"
      },
      {
        "enquiryDate": "",
        "parentName": "Vineeta Verma",
        "childName": "Samarth Verma",
        "phone": "9902925867",
        "age": 7,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP 2"
      },
      {
        "enquiryDate": "",
        "parentName": "Vineeta Verma",
        "childName": "Samarth Verma",
        "phone": "9902925867",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP 2"
      },
      {
        "enquiryDate": "",
        "parentName": "Nidhi Sinha",
        "childName": "Armaan Sinha",
        "phone": "7004822189",
        "age": 7,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP 3"
      },
      {
        "enquiryDate": "",
        "parentName": "Namrata",
        "childName": "Reyaansh",
        "phone": "9650611776",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Namrata",
        "childName": "Reyaansh",
        "phone": "9650611776",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Namrata",
        "childName": "Adya",
        "phone": "9650611776",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Namrata",
        "childName": "Adya",
        "phone": "9650611776",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Nidhi Kaushal(OH)",
        "childName": "Raghav Kumar",
        "phone": "9845529581",
        "age": 6,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Monisha",
        "childName": "Gianna Niya Machamada",
        "phone": "9886654520",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Monisha",
        "childName": "Gianna Niya Machamada",
        "phone": "9886654520",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Kartheek",
        "childName": "Dheera",
        "phone": "9980342797",
        "age": 8,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Rahul",
        "childName": "Kiara",
        "phone": "9899989419",
        "age": 8,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "shantanu",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Charu",
        "childName": "Sayesha",
        "phone": "9986363988",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Charu",
        "childName": "Sayesha",
        "phone": "9986363988",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Arpit",
        "childName": "Khyati",
        "phone": "9930862264",
        "age": 4,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Kinnari",
        "childName": "Kimaya",
        "phone": "9004299299",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Shantanu",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Pavitra",
        "childName": "Varsha",
        "phone": "9916001937",
        "age": 11,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Shantanu",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Kunjal",
        "childName": "Hetvik",
        "phone": "9821086805",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Santhosh",
        "childName": "Saanvika",
        "phone": "996426605",
        "age": 8,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Shantanu",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Kunjal",
        "childName": "Hetvik",
        "phone": "9821086805",
        "age": 7,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Pavitra",
        "childName": "Aarav",
        "phone": "9916001937",
        "age": 11,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Pooja parmar",
        "childName": "Ahaan Negi",
        "phone": "7738204980",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Girish",
        "childName": "Delisha",
        "phone": "9886133589",
        "age": 11,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": "DNP"
      },
      {
        "enquiryDate": "",
        "parentName": "Ashish",
        "childName": "Anaya",
        "phone": "9032003282",
        "age": 11,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Namrata",
        "childName": "Reyaansh",
        "phone": "9650611776",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Sumedha",
        "childName": "Atharv",
        "phone": "9650307490",
        "age": 4,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "Taochi",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Namrata",
        "childName": "Reyaansh",
        "phone": "9650611776",
        "age": 7,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Namrata",
        "childName": "Adya",
        "phone": "9650611776",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Namrata",
        "childName": "Adya",
        "phone": "9650611776",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Girish",
        "childName": "Delisha",
        "phone": "9886133589",
        "age": 11,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Shanthanu",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Ashish",
        "childName": "Anaya",
        "phone": "9032003282",
        "age": 11,
        "program": "Dance",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Shanthanu",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Rosana",
        "childName": "Ruvika",
        "phone": "9620901159",
        "age": 5,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Pavitra",
        "childName": "Varsha",
        "phone": "9916001937",
        "age": 11,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "Shantanu",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Pavitra",
        "childName": "Aarav",
        "phone": "9916001937",
        "age": 11,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Naavya Jadhav",
        "childName": "Shrirang Jadhav",
        "phone": "8050005696",
        "age": 7,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Simrat",
        "childName": "Siddharth",
        "phone": "9884297398",
        "age": 5,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Simrat",
        "childName": "Siddharth",
        "phone": "9884297398",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Mayur Agrawal",
        "childName": "vivaan",
        "phone": "9986516272",
        "age": 6,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Monisha",
        "childName": "Gianna Niya Machamada",
        "phone": "9886654520",
        "age": 9,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Monisha",
        "childName": "Gianna Niya Machamada",
        "phone": "9886654520",
        "age": 9,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Prashant Oberoi",
        "childName": "Kabir",
        "phone": "8147881532",
        "age": 8,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Prashant Oberoi",
        "childName": "Kabir",
        "phone": "8147881532",
        "age": 8,
        "program": "Public Speaking",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Prashant Oberoi",
        "childName": "Kabir",
        "phone": "8147881532",
        "age": 8,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Prashant Oberoi",
        "childName": "Kabir",
        "phone": "8147881532",
        "age": 8,
        "program": "Robotics",
        "trialDate": "2026-05-31",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Praveen Kumar",
        "childName": "Dhruveen K",
        "phone": "9731500511",
        "age": 11,
        "program": "Robotics",
        "trialDate": "",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Mayur Agrawal",
        "childName": "vivaan",
        "phone": "9986516272",
        "age": 6,
        "program": "Robotics",
        "trialDate": "2026-06-07",
        "attendance": "Scheduled",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Yes",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "Pallavi Agarwal",
        "childName": "Atharv Agarwal",
        "phone": "8090402687",
        "age": 5,
        "program": "Public Speaking",
        "trialDate": "2026-06-06",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      },
      {
        "enquiryDate": "",
        "parentName": "komal",
        "childName": "Viyansh",
        "phone": "9503006776",
        "age": 8,
        "program": "Public Speaking",
        "trialDate": "2026-06-08",
        "attendance": "Yes",
        "followUpOwner": "",
        "followUpDate": "",
        "converted": "Follow-up Pending",
        "callStatus": ""
      }
    ],
    "inventory": [
      {
        "item": "Robotics kit",
        "category": "Robotics",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 10,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Watch your step",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Tale trail",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Skill badge",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Stickers for dice",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 2,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Speech a palooza",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Guess me",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Body Talk",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Debate Duel",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Shuffle",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Train of thought",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Dice",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 6,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Meeples",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Pitch perfect",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Speaker",
        "category": "Dance",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Masking tape",
        "category": "Robotics",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Tokens",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 3,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Sharpener",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Timer",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Storage box",
        "category": "Robotics",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Soft ball",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Pen",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "White Charcoal pencils",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Sign pen",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "What's that sound?",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Art Gym",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": "",
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Yarn",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 4,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Pipe cleaner",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Shape fusion",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "imagine that",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "spaggle",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "colour flip",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Script flip",
        "category": "PS",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "glue",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 10,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "colour pencils",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "erasable markers",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 10,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "drawing pencils",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "clay",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "crayons",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "soft pastels",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "acrylic colours",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "brush pens",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "palette",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "no spill pot",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "tempera paints",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 12,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "container",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "artventure",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "ruler",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "black paper",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "paint brush",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 2,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "art fusion",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "drawing book",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 15,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "oil pastels",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "A3",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Cue Cards — Animals B1",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Cue Cards — Animals B2",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Cue Cards — Birds B1",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Cue Cards — Birds B2",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Cue Cards — Buildings B1",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Cue Cards — Buildings B2",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Cue Cards — Food B1",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Cue Cards — Food B2",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Cue Cards — Nature B1",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Cue Cards — Nature B2",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Cue Cards — Vehicles B1",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Cue Cards — Vehicles B2",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Cue Cards — Background (Landscape A4)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "Cue Cards — Background (Portrait A4)",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "A4",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      },
      {
        "item": "wax crayons",
        "category": "Art",
        "capexOpex": "Capex",
        "purpose": "Trials + Regular",
        "dispatched": 1,
        "received": "",
        "balance": "",
        "notes": ""
      }
    ],
    "issues": [],
    "payout": {
      "sharePercent": 15,
      "accountDetails": "—",
      "rows": []
    },
    "payments": [
      {
        "parentName": "Pallavi Chaudhary",
        "children": "Atharv Nehra",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_SvyROsKCvqstio",
        "date": "2026-05-31",
        "phone": "918884751418"
      },
      {
        "parentName": "Pushkar Kumar",
        "children": "Armaan Sinha",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SvyK9es8KGS6Bz",
        "date": "2026-05-31",
        "phone": "919916203363"
      },
      {
        "parentName": "Simrat Hanspal",
        "children": "Siddharth Talari",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_SvyAfs1W6gVgW3",
        "date": "2026-05-31",
        "phone": "919884297398"
      },
      {
        "parentName": "Ravishankar R",
        "children": "Sathvika R",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_Svy3nsWaXNh9Gb",
        "date": "2026-05-31",
        "phone": "919632968587"
      },
      {
        "parentName": "Charu Aggarwal",
        "children": "Sayesha Aggarwal",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_Svy1Sgjyg0OpTN",
        "date": "2026-05-31",
        "phone": "919986363988"
      },
      {
        "parentName": "Ramya Rajeev",
        "children": "Nitara Nair",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_Svxjp4PVtHHSdB",
        "date": "2026-05-31",
        "phone": "919742476258"
      },
      {
        "parentName": "Shrirang Jadhav",
        "children": "Naavya Jadhav",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SvxTYKQeeoldF3",
        "date": "2026-05-31",
        "phone": "918050005696"
      },
      {
        "parentName": "Pooja Parmar",
        "children": "Ahaan Negi",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_SvxJt0wRbOpmGM",
        "date": "2026-05-31",
        "phone": "917738204980"
      },
      {
        "parentName": "Pavithra parthasarathy",
        "children": "Aarav and varsha",
        "categories": "2 Categories, twice/week or 4+ enrolments",
        "month": "",
        "amount": 4500,
        "status": "Paid",
        "paymentId": "pay_Svx41Y9WfSYg83",
        "date": "2026-05-31",
        "phone": "919916001937"
      },
      {
        "parentName": "Rosanna Gulati",
        "children": "Ruvika Gulati",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SvwkqOr3vGNtAQ",
        "date": "2026-05-31",
        "phone": "919620901159"
      },
      {
        "parentName": "Heena Singla",
        "children": "Kyra Tayal",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_SvwOAjDSgHE97N",
        "date": "2026-05-31",
        "phone": "919008102202"
      },
      {
        "parentName": "Neha roy",
        "children": "Veeraj roy",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SvuluZvtBVwRq0",
        "date": "2026-05-31",
        "phone": "917709739177"
      },
      {
        "parentName": "Kunjal Tanna",
        "children": "Hetvik Vudhya Setu",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_SvuHXi92ZPAf2Y",
        "date": "2026-05-31",
        "phone": "919821086805"
      },
      {
        "parentName": "Praanshu Gupta",
        "children": "Anaisha Gupta",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_Svu3DDkj1OGjPq",
        "date": "2026-05-31",
        "phone": "919818966918"
      },
      {
        "parentName": "Kinnari Shah",
        "children": "Kimaya Chheda",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_SvsTWuCahVOpvN",
        "date": "2026-05-31",
        "phone": "919004299299"
      },
      {
        "parentName": "Arya",
        "children": "Shambhavi Nayak",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SvrgEUqjKMgjqP",
        "date": "2026-05-31",
        "phone": "918897413742"
      },
      {
        "parentName": "Rahul Bajaj",
        "children": "Kiara Bajaj",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_SvrBpGEZPytoHI",
        "date": "2026-05-31",
        "phone": "919899989419"
      },
      {
        "parentName": "Monisha Devaiah",
        "children": "Gianna Niya Machamada",
        "categories": "2 Categories, twice/week or 4+ enrolments",
        "month": "",
        "amount": 4500,
        "status": "Paid",
        "paymentId": "pay_SudAnUIdu4U02Z",
        "date": "2026-05-28",
        "phone": "919886654520"
      },
      {
        "parentName": "Neha Agarwal",
        "children": "Reyansh Agarwal",
        "categories": "Combination of 2 enrolments",
        "month": "",
        "amount": 2250,
        "status": "Paid",
        "paymentId": "pay_Sv0XXrCrCKgS3D",
        "date": "2026-05-29",
        "phone": "919997166247"
      },
      {
        "parentName": "Neha Agarwal",
        "children": "Vihaan Agarwal",
        "categories": "Combination of 2 enrolments",
        "month": "",
        "amount": 2250,
        "status": "Paid",
        "paymentId": "pay_Sv0ahXW4ykiQnv",
        "date": "2026-05-29",
        "phone": "919997166247"
      },
      {
        "parentName": "Namrata Rani",
        "children": "Adya & Reyaansh Singh",
        "categories": "Combination of 4 enrolments",
        "month": "",
        "amount": 4125,
        "status": "Paid",
        "paymentId": "pay_SvvRVZISB58Bq9",
        "date": "2026-05-31",
        "phone": "919650611776"
      },
      {
        "parentName": "Namrata Rani",
        "children": "Adya & Reyaansh Singh",
        "categories": "Combination of 4 enrolments",
        "month": "",
        "amount": 4125,
        "status": "Paid",
        "paymentId": "pay_SvvXyxOw1Y3DfI",
        "date": "2026-05-31",
        "phone": "919650611776"
      },
      {
        "parentName": "Mayur Agrawal",
        "children": "Vivaan Agrawal",
        "categories": "Combination of 3 enrolments",
        "month": "",
        "amount": 3400,
        "status": "Paid",
        "paymentId": "pay_SvyyVBnglfUCGy",
        "date": "2026-05-31",
        "phone": "919986516272"
      },
      {
        "parentName": "Kriti Jain",
        "children": "Mandana & Mayeem Diwakar",
        "categories": "2 Categories, twice/week or 4+ enrolments",
        "month": "",
        "amount": 4500,
        "status": "Paid",
        "paymentId": "pay_SwDvGP92A97cH3",
        "date": "2026-06-01",
        "phone": "919916899920"
      },
      {
        "parentName": "Arya",
        "children": "Shambhavi",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1200,
        "status": "Paid",
        "paymentId": "pay_SvvCL4AfuH6jLc",
        "date": "2026-05-31",
        "phone": "918897413742"
      },
      {
        "parentName": "Prashant Oberoi",
        "children": "Kabir Oberoi",
        "categories": "2 Categories, twice/week or 4+ enrolments",
        "month": "",
        "amount": 4500,
        "status": "Paid",
        "paymentId": "pay_SwE7tqfo7a37no",
        "date": "2026-06-01",
        "phone": "918147881532"
      },
      {
        "parentName": "Srilakshmi Tavva",
        "children": "Sathvika Tavva",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SwJhjiusuHEDdj",
        "date": "2026-06-01",
        "phone": "919663645566"
      },
      {
        "parentName": "Arthi Praveen Kumar",
        "children": "Rithwik Rithanya",
        "categories": "1 Category, twice/week + 1 Category, once/week",
        "month": "",
        "amount": 3825,
        "status": "Paid",
        "paymentId": "pay_SwJlXmWgCa0EXC",
        "date": "2026-06-01",
        "phone": "917406206111"
      },
      {
        "parentName": "Ruby Shah yadav",
        "children": "Lakshya yadav",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_Sx1ytr7lZkunVl",
        "date": "2026-06-03",
        "phone": "916362308757"
      },
      {
        "parentName": "Praveen Kumar",
        "children": "Dhruveen K",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_Sxs13DcIGlYWmL",
        "date": "2026-06-05",
        "phone": "919731500511"
      },
      {
        "parentName": "Priya Rai",
        "children": "Kanishk Sharma",
        "categories": "1 Category, twice/week or 2 Categories, once/week",
        "month": "",
        "amount": 2700,
        "status": "Paid",
        "paymentId": "pay_SxusjAyvotyev7",
        "date": "2026-06-05",
        "phone": "919611211223"
      },
      {
        "parentName": "Asit Pradhan",
        "children": "Riona Pradhan",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SxwoJq88cDd2E0",
        "date": "2026-06-05",
        "phone": "919885192100"
      },
      {
        "parentName": "Sreedevi KV",
        "children": "Ameya KV",
        "categories": "1 Category, Once/week",
        "month": "",
        "amount": 1500,
        "status": "Paid",
        "paymentId": "pay_SyNv7e3ne7H4fQ",
        "date": "2026-06-06",
        "phone": "919739885358"
      }
    ],
    "attendance": {
      "week": "Recent sessions",
      "dates": [],
      "rows": [
        {
          "childName": "Rithwik",
          "batch": "",
          "marks": []
        },
        {
          "childName": "Rithanya",
          "batch": "",
          "marks": []
        },
        {
          "childName": "Rithanya",
          "batch": "",
          "marks": []
        },
        {
          "childName": "Shambhavi",
          "batch": "",
          "marks": []
        },
        {
          "childName": "Shambhavi",
          "batch": "",
          "marks": []
        },
        {
          "childName": "Kimaya",
          "batch": "",
          "marks": []
        },
        {
          "childName": "Vivaan Agrawal",
          "batch": "",
          "marks": []
        },
        {
          "childName": "Vihaan Agarwal",
          "batch": "",
          "marks": []
        },
        {
          "childName": "Reyansh Agarwal",
          "batch": "",
          "marks": []
        },
        {
          "childName": "Reyansh Agarwal",
          "batch": "",
          "marks": []
        },
        {
          "childName": "Vihaan Agarwal",
          "batch": "",
          "marks": []
        },
        {
          "childName": "Veeraj Roy",
          "batch": "",
          "marks": []
        },
        {
          "childName": "Natasha Paliwal",
          "batch": "",
          "marks": []
        },
        {
          "childName": "Natasha Paliwal",
          "batch": "",
          "marks": []
        }
      ]
    },
    "enrolmentOptions": {
      "families": [
        {
          "id": "f1",
          "name": "Arthi",
          "children": [
            "Rithanya",
            "Rithwik"
          ]
        },
        {
          "id": "f2",
          "name": "Arya",
          "children": [
            "Shambhavi"
          ]
        },
        {
          "id": "f3",
          "name": "Kinnari",
          "children": [
            "Kimaya"
          ]
        },
        {
          "id": "f4",
          "name": "Mayur Agrawal",
          "children": [
            "Vivaan Agrawal"
          ]
        },
        {
          "id": "f5",
          "name": "Neha Agarwal",
          "children": [
            "Reyansh Agarwal",
            "Vihaan Agarwal"
          ]
        },
        {
          "id": "f6",
          "name": "Neha Roy",
          "children": [
            "Veeraj Roy"
          ]
        },
        {
          "id": "f7",
          "name": "Nishant Paliwal(OH )",
          "children": [
            "Natasha Paliwal"
          ]
        },
        {
          "id": "f8",
          "name": "Pallavi Chaudhary",
          "children": [
            "Atharv Nehra"
          ]
        },
        {
          "id": "f9",
          "name": "Pooja parmar",
          "children": [
            "Ahaan Negi"
          ]
        },
        {
          "id": "f10",
          "name": "Praanshu Gupta",
          "children": [
            "Anaisha Fupta"
          ]
        },
        {
          "id": "f11",
          "name": "Pushkar",
          "children": [
            "Armaan Sinha"
          ]
        },
        {
          "id": "f12",
          "name": "Rahul",
          "children": [
            "Kiara"
          ]
        },
        {
          "id": "f13",
          "name": "Ramya",
          "children": [
            "Nitara"
          ]
        },
        {
          "id": "f14",
          "name": "Aditya",
          "children": [
            "Sathvika"
          ]
        },
        {
          "id": "f15",
          "name": "Namrata",
          "children": [
            "Adya",
            "Reyaansh"
          ]
        },
        {
          "id": "f16",
          "name": "Nidhi Kaushal(OH)",
          "children": [
            "Raghav Kumar"
          ]
        },
        {
          "id": "f17",
          "name": "Monisha",
          "children": [
            "Gianna Niya Machamada"
          ]
        },
        {
          "id": "f18",
          "name": "Charu",
          "children": [
            "Sayesha"
          ]
        },
        {
          "id": "f19",
          "name": "Pavitra",
          "children": [
            "Aarav",
            "Varsha"
          ]
        },
        {
          "id": "f20",
          "name": "Kunjal",
          "children": [
            "Hetvik"
          ]
        },
        {
          "id": "f21",
          "name": "Rosana",
          "children": [
            "Ruvika"
          ]
        },
        {
          "id": "f22",
          "name": "Naavya Jadhav",
          "children": [
            "Shrirang Jadhav"
          ]
        },
        {
          "id": "f23",
          "name": "Simrat",
          "children": [
            "Siddharth"
          ]
        },
        {
          "id": "f24",
          "name": "Kriti Jain",
          "children": [
            "Mandana Diwakar",
            "Mayeem"
          ]
        },
        {
          "id": "f25",
          "name": "Prashant Oberoi",
          "children": [
            "Kabir"
          ]
        },
        {
          "id": "f26",
          "name": "Srilakshmi T",
          "children": [
            "Sathvika T"
          ]
        },
        {
          "id": "f27",
          "name": "Ruby shah Yadav",
          "children": [
            "Lakshya"
          ]
        },
        {
          "id": "f28",
          "name": "ruby shah Yadav",
          "children": [
            "Lakshya"
          ]
        },
        {
          "id": "f29",
          "name": "Sreedevi",
          "children": [
            "Ameya"
          ]
        }
      ],
      "programs": [
        "Art",
        "Public Speaking",
        "Robotics",
        "Dance"
      ]
    },
    "dashboard": {
      "activeEnrolments": 65,
      "activeFamilies": 29,
      "trialsThisMonth": 120,
      "openIssues": 0,
      "revenueByMonth": [],
      "revenueByProgram": [
        {
          "program": "Public Speaking",
          "enrolments": 33,
          "revenue": 33000
        },
        {
          "program": "Robotics",
          "enrolments": 31,
          "revenue": 38750
        },
        {
          "program": "Dance",
          "enrolments": 1,
          "revenue": 1000
        }
      ],
      "attendance": {
        "present": 0,
        "absent": 0,
        "holiday": 0
      }
    }
  }
}
